import { Component, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { take } from 'rxjs/operators';
import { AzureMapsService } from '../../services/azure-maps.service';
import { GridDataResult, DataStateChangeEvent, GridComponent, RowClassArgs } from '@progress/kendo-angular-grid';
import { State, orderBy, process, CompositeFilterDescriptor, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { EmployeeMultiselectDialog } from '../employee-popup/employee-popup.component';
import { formatDate } from '@angular/common';
//import { utils } from 'xlsx';
//import { Feature } from 'angular-maps/src/services/google/google-map-types';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { CityService } from '../../services/city.service';
import { CRMService } from '../../services/crm.service';
import { CSEService } from '../../services/cse.service';
import { DataService } from '../../services/data.service';
import { EmployeeService } from '../../services/employees.service';
import { ERPService } from '../../services/erp.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
import {
    APIResponse,
    ApplicationControl,
    CheckCall,
    Employee,
    OrderEventSchedule,
    OrderEventScheduleAddMultiple,
    OrderEventScheduleView,
    OrderEventType,
    OrderStop,
    ProgressBarWithText,
    QuoteOrder,
    QuoteOrderLine,
    QuoteOrderLineOrderEventExclude,
    ReferenceNumber,
    SearchCheckCall,
    SearchCityState,
    SearchCustomer,
    SearchMacropointStopAlertHistory,
    SearchOrderEventType,
    SearchOrderStop,
    SearchQuoteOrderLine,
    SearchReferenceType,
    SearchTagType,
    StopLateReason,
    TrackingBoard,
    TrackingEventEmail,
    TrackingGroup,
    TrackingGroupPriority,
    TravelEstimate,
    UnitOfMeasure
} from '../../models/models';
//import DataTileSource from 'ol/source/DataTile';


//const flatten = filter => {
//    const filters = (filter || {}).filters;
//    if (filters) {
//        return filters.reduce((acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
//    }
//    return [];
//};

//const distinctCarrierReps = data => data
//    .map(x => x.fullName)
//    .filter((x, idx, xs) => xs.findIndex(y => y.fullName === x.fullName) === idx);

@Component({
    selector: 'tracking-dashboard',
    templateUrl: './tracking-dashboard.component.html',
    providers: [{
        provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
    }],
    standalone: false
})
export class TrackingDashboard implements OnDestroy, OnInit {
    @ViewChild(GridComponent, { static: false }) public trackingGrid!: GridComponent;
    @ViewChild(GridComponent, { static: false }) public scheduleGrid!: GridComponent;
    @ViewChild('stepper', { static: false }) stepper!: MatStepper;
    @HostListener('window:beforeunload', ['$event'])
    beforeunloadHandler(event) {
        event.preventDefault();
        if (this.selectedTrackingBoard.quoteOrderID > 0) {
            event.returnValue = 'Any unsaved data will be lost, and the Order will be unlocked.';
            //console.log("beforeunloadHandler", this.quoteOrder.quoteOrderID, this.recordLockSource);
            this.recordLockService.clearRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
        }
        return false;
    }

    //public filter: CompositeFilterDescriptor = {} as CompositeFilterDescriptor;
    private isSelectedRowLoading: boolean = false;
    public isButtonClicked: boolean = false;
    public isRemainOpenAfterSave: boolean = false;
    public isStopValid: boolean = true;
    public isNonStopDateValid: boolean = true;
    public isScheduleViewDateValid: boolean = true;
    public isExportHub: boolean = false;
    public isErrorSavingData: boolean = false;
    public isLLDDepartedNotConfirmed: boolean = false;
    public errorSavingDataMessage: string = "";
    public isLoading: boolean = false;
    public isAllTrackingComplete: boolean = false;
    public isPreviousLegComplete: boolean = true;
    public isNextLegOverlap: boolean = false;
    public isTrackingBoardLoading: boolean = false;
    public isTrackingEventLoading: boolean = false;
    public isScheduleLoading: boolean = false;
    public isEscalation: boolean = false;
    public isValidExternalTrackingLink: boolean = true;
    private isSetDayBackClicked: boolean = false;
    public hasRoute: boolean = false;
    public divFlags = {
        'tracking': true,
        'order stops': true,
        'load stops': true,
        'checkCalls': true,
        'alerts': false,
        'map': true
    };
    public cseAppControls: ApplicationControl[] = [];
    public orderAppControls: ApplicationControl[] = [];
    public trackingBoard: TrackingBoard[] = [];
    //public trackingBoardAll: TrackingBoard[] = [];
    public trackingBoardNextEvents: TrackingBoard[] = [];
    public numRecords: number = 1;
    public trackingBoardSingle: TrackingBoard[] = [];
    public trackingGroupStatus: TrackingGroup[] = [];
    public selectedTrackingBoard = {} as TrackingBoard;
    public orderEventSchedule: OrderEventSchedule[] = [];
    public fullOrderEventSchedule: OrderEventSchedule[] = [];
    public orderEventScheduleView: OrderEventScheduleView[] = [];
    public orderEventProgress: ProgressBarWithText[] = [];
    public orderEventTypes: OrderEventType[] = [];
    public referenceTypeList: SearchReferenceType[] = [];
    public tagTypeList: SearchTagType[] = [];
    public quoteOrderStops: OrderStop[] = [];
    public orderStops: OrderStop[] = [];
    public searchOrderStops: SearchOrderStop[] = [];
    public stopLateReasonList: StopLateReason[] = [];
    //public nextOrderStopEvent: OrderEventSchedule | undefined;
    //public isNextOrderStopEventSave: boolean = false;
    //public isNextStopValid: boolean = true;
    public macropointURL: string = "";
    public newReferenceNumber: string = "";
    public newReferenceType: string = "BL#";
    public pieceUnits: UnitOfMeasure[] = [];
    public weightUnits: UnitOfMeasure[] = [];
    //public checkCallsOrig: CheckCall[] = [];
    public checkCalls: SearchCheckCall[] = [];
    private allEmployees: Employee[] = [];
    public carrierReps: Employee[] = [];
    public accountManagers: Employee[] = [];
    public logisticSpecialists: Employee[] = [];
    public countries: string[] = [];
    public c2cList: string[] = [];
    //public customerRep: Employee = {} as Employee;
    public carrierRep: Employee = {} as Employee;
    private searchCustomer: SearchCustomer = {} as SearchCustomer;
    public referenceNumbers: ReferenceNumber[] = [];
    public stopAlerts: SearchMacropointStopAlertHistory[] = [];
    private travelEstimate: TravelEstimate = {} as TravelEstimate;
    public currentGridEdit: GridComponent | undefined;
    public currentGridName: string = "";
    public scheduleViewSelectedEventType: string = "";
    public trackingBoardView: GridDataResult = { data: [], total: 0 };
    //public trackingBoardDetailView: GridDataResult = { data: [], total: 0 };
    public scheduleView: GridDataResult = { data: [], total: 0 };
    //public stopsView: GridDataResult = { data: [], total: 0 };
    //public checkCallsView: GridDataResult = { data: [], total: 0 };
    public trackingBoardState: State = { skip: 0, take: 20 };
    //public checkCallsState: State = { skip: 0, take: 10, sort: [{ dir: 'desc', field: 'dateOfCall' }] };
    //public isMacropointCheckCall: boolean = false;
    public scheduleViewState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'orderEventSequence' }] };
    private carrierRepsFilter: any[] = [];
    private accountManagersFilter: any[] = [];
    private logisticSpecialistsFilter: any[] = [];
    private tagTypesFilter: any[] = [];
    private originCountryFilter: any[] = [];
    private destinationCountryFilter: any[] = [];
    private c2cFilter: any[] = [];
    private quoteOrderID: number = 0;
    private quoteOrderLineID: number = 0;
    public orderEventSequenceMin: number = 0;
    public orderEventSequenceMax: number = 0;
    private delayMinutes: number = 0;
    private delayTrackingEventETAMinutes: number = 15;
    private delayTrackingEventType: number = 0;
    private isRequireLateReason: boolean = false;
    private isLateForArv: boolean = false;

    // Load Stops grid
    public stopsRefreshDate: Date = new Date();
    public checkCallRefreshDate: Date = new Date();

    public isScheduleViewEdit: boolean = false;
    public isAddMultipleEvents: boolean = false;
    public isConvertMMtoCLR: boolean = false;
    //public addMultipleMMBeginDate: Date = new Date();
    //public addMultipleMMHoursToCheck: number = 0;
    //public addMultipleMMNotes: string = "";
    public addMultiple: OrderEventScheduleAddMultiple = {} as OrderEventScheduleAddMultiple;

    private editedScheduleView: OrderEventScheduleView | undefined;
    private editedOrderStop: OrderStop = {} as OrderStop;
    public currentOrderEventSchedule: OrderEventSchedule = {} as OrderEventSchedule;
    public editedOrderEventSchedule: OrderEventSchedule = {} as OrderEventSchedule;
    public excludeLTE: QuoteOrderLineOrderEventExclude = {} as QuoteOrderLineOrderEventExclude;
    public isMacropointLTE: boolean = false;
    public isExcludeLTE: boolean = false;
    public isExcludeLTEClicked: boolean = false;
    private searchLineList: SearchQuoteOrderLine[] = [];
    public searchLine: SearchQuoteOrderLine = {} as SearchQuoteOrderLine;
    public quoteOrder: QuoteOrder = {} as QuoteOrder;
    private quoteOrderLine: QuoteOrderLine = {} as QuoteOrderLine;

    //public filteredCities: Observable<City[]> = new Observable<City[]>();
    //public cityList: City[] = new Array();
    public searchOrderEventTypes: SearchOrderEventType[] = [];
    public checkCallEventTypes: SearchOrderEventType[] = []; //['CHK', 'FUT', 'TRP'];
    public scheduleEventTypes: SearchOrderEventType[] = [];
    public scheduleViewEventTypes: SearchOrderEventType[] = [];
    public ppcViewEventType: SearchOrderEventType[] = [];
    public trackingEventTypes: SearchOrderEventType[] = [];
    public addMultipleEventTypes: SearchOrderEventType[] = [];

    public cityControl = new UntypedFormControl();
    trackingDashForm: UntypedFormGroup = new UntypedFormGroup({
        cityControl: new UntypedFormControl('')
    });

    // Tracking Event Form: Check Call
    public trackingCheckCall: CheckCall = {} as CheckCall;
    public isEditing: boolean = false;
    public isCheckCall: boolean = false;
    public isCheckCallCitySet: boolean = false;
    public isOrderEventSave: boolean = false;
    public isNonStopEventSave: boolean = false;
    //public checkCallCityControl = new UntypedFormControl('');
    public defaultCheckCallCity: string = "";
    //public checkCallNotes: string = "";
    //public systemNotes: string = "";
    public checkCallMiles: number = -1;
    public checkCallCity: SearchCityState = {} as SearchCityState;
    public checkCallCityID: number = 0;
    public tzOrderEventDate: Date = new Date();
    public fetchingRoute: boolean = false;

    private recordLockAction: string = "";
    private recordLockSource: string = "Tracking Dashboard";
    private recordLockHandleEvent: any;
    private recordLockHandleSchedule: OrderEventSchedule = {} as OrderEventSchedule;

    checkCallForm: UntypedFormGroup = new UntypedFormGroup({
        checkCallCityControl: new UntypedFormControl('')
    });

    constructor(private applicationControlService: ApplicationControlService, private cityService: CityService,
        private dataService: DataService, private crmService: CRMService, private cseService: CSEService,
        private erpService: ERPService, private notificationService: NotificationService,
        private orderService: OrderService, private recordLockService: RecordLockService,
        route: ActivatedRoute, private titleService: Title, private router: Router,
        private azureMapsService: AzureMapsService, private employeeService: EmployeeService,
        private utilService: UtilService,
        public dialog: MatDialog, private ngZone: NgZone) {
        this.titleService.setTitle('Track And Trace Dashboard');
        this.cityControl = new UntypedFormControl();
        this.cityControl.disable();
        //this.filteredCities = this.cityControl.valueChanges
        //    .pipe(
        //        startWith(''),
        //        map(city => city ? this.filterCities(city) : new Array())
        //    );
        this.applicationControlService.getApplicationControlsByAppName("CSE").subscribe(result => {
            this.cseAppControls = result;
        });

        this.applicationControlService.getApplicationControlsByAppName("Order+page").subscribe(result => {
            this.orderAppControls = result;
        });

        this.applicationControlService.getApplicationControlsByAppName("ArvDelayETAMinutes").subscribe(result => {
            if (result.length > 0) {
                this.delayTrackingEventETAMinutes = parseInt(result[0].appSettingValue);
            }
        });

        this.applicationControlService.getApplicationControlsByAppName("ExportHub").subscribe(result => {
            if (result.length > 0) {
                var appValue = result[0].appSettingValue;
                if (appValue == "1") {
                    this.isExportHub = true;
                }
                else {
                    this.isExportHub = false;
                }
            }
        });

        this.orderService.getUnitOfMeasures().subscribe(result => {
            this.pieceUnits = result.filter(u => u.piecesUnitInd == true);
            this.weightUnits = result.filter(u => u.weightUnitInd == true);
        });

        this.orderService.getOrderEventTypes().subscribe(result => {
            this.orderEventTypes = result.resultCollection;
        });

        this.orderService.getTrackingGroups().subscribe(result => {
            this.trackingGroupStatus = result.resultCollection;
        });

        this.orderService.getSearchTagTypes().subscribe(result => {
            this.tagTypeList = result.resultCollection;
        });

        this.orderService.getAllStopLateReason().subscribe(result => {
            this.stopLateReasonList = result.resultCollection;
        });

        this.getReferenceTypes();
    }

    ngOnInit() {
        this.initFields();
        //this.getCities();
        this.getCarrierReps();
        this.getAccountManagers();
        this.getLogisticSpecialists();
        this.getSearchOrderEventTypes();
        this.getTrackingBoard({} as TrackingBoard);
        this.initRecordLock();
    }

    ngOnDestroy() {
        if (this.selectedTrackingBoard.quoteOrderID > 0) {
            this.recordLockService.clearRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
        }
    }

    private initFields() {
        this.isButtonClicked = false;
        this.isErrorSavingData = false;
        this.isLLDDepartedNotConfirmed = false;
        this.errorSavingDataMessage = "";
        this.isLoading = false;
        this.isScheduleLoading = false;
        this.isTrackingBoardLoading = false;
        this.isTrackingEventLoading = false;

        this.isEditing = false;

        this.isOrderEventSave = false;
        this.isCheckCall = false;
        this.isCheckCallCitySet = false;
        this.isNonStopEventSave = false;
        //this.isEscalation = false;
        this.isNonStopDateValid = true;
        this.isScheduleViewDateValid = true;

        //this.checkCallForm.controls["checkCallCityControl"].setValue("");
        //this.checkCallNotes = "";
        //this.systemNotes = "";
        this.checkCallMiles = -1;
        this.newReferenceType = "BL#";
        this.newReferenceNumber = "";
        this.checkCallCity = {} as SearchCityState;
        this.checkCallCityID = 0;
        this.defaultCheckCallCity = "";
        this.trackingCheckCall = {} as CheckCall;
        this.searchCustomer = {} as SearchCustomer;

        //this.nextOrderStopEvent = undefined;
        //this.isNextOrderStopEventSave = false;
        //this.isNextStopValid = true;

        this.isScheduleViewEdit = false;
        this.isAddMultipleEvents = false;
        this.isConvertMMtoCLR = false;
        //this.addMultipleMMBeginDate = new Date();
        //this.addMultipleMMHoursToCheck = 0;
        //this.addMultipleMMNotes = "";
        this.addMultiple = {} as OrderEventScheduleAddMultiple;
        this.delayMinutes = 0;
        this.delayTrackingEventETAMinutes = 15;
        this.delayTrackingEventType = 0;

        this.isLateForArv = false;
        this.isRequireLateReason = false;

        this.editedScheduleView = undefined;
        this.editedOrderEventSchedule = {} as OrderEventSchedule;
        this.editedOrderStop = {} as OrderStop;
        //this.editedCheckCall = {} as CheckCall;
    }

    //getCities() {
    //    this.cityService.getCitiesDropdown().subscribe(result => {
    //        this.cityList = result;
    //        this.cityControl.enable();
    //    });
    //}

    private getCarrierReps() {
        this.isLoading = true;
        this.employeeService.getEmployeesByGroupName("carrierrep").subscribe(result => {
            this.isLoading = false;
            this.carrierReps = result;
        });
    }

    private getAccountManagers() {
        this.isLoading = true;
        this.employeeService.getEmployeesByGroupName("account managers").subscribe(result => {
            this.isLoading = false;
            this.accountManagers = result;
        });
    }

    private getLogisticSpecialists() {
        this.isLoading = true;
        this.employeeService.getEmployeesByGroupName("logistic specialists").subscribe(result => {
            this.isLoading = false;
            this.logisticSpecialists = result;
        });
    }

    private getCountries() {
        this.countries.length = 0;
        for (var i = 0; i < this.trackingBoard.length; i++) {
            var originCountry = this.trackingBoard[i].originCountryAbbreviation;
            var destinationCountry = this.trackingBoard[i].destinationCountryAbbreviation;
            if (this.countries.indexOf(originCountry) < 0) {
                this.countries.push(originCountry);
            }
            if (this.countries.indexOf(destinationCountry) < 0) {
                this.countries.push(destinationCountry);
            }
        }
        //console.log("getCountries", this.countries);
    }

    private getC2CList() {
        this.c2cList.length = 0;
        for (var i = 0; i < this.trackingBoard.length; i++) {
            var c2c = this.trackingBoard[i].legCntryToCntry;
            if (this.c2cList.indexOf(c2c) < 0) {
                this.c2cList.push(c2c);
            }
        }
        //console.log("getC2CList", this.c2cList);
    }

    private getStatusTextColor(priority: number) {
        switch (priority) {
            case 1: {
                return "danger";
                break;
            }
            case 2: {
                return "warning";
                break;
            }
            case 3: {
                return "primary";
                break;
            }
            case 4: {
                return "success";
                break;
            }
            default: {
                return "dark";
                break;
            }
        }
    }

    private getStatusBackgroundColor(priority: number) {
        switch (priority) {
            case 1: {
                return "danger";
                break;
            }
            case 2: {
                return "warning";
                break;
            }
            case 3: {
                return "primary";
                break;
            }
            case 4: {
                return "success";
                break;
            }
            default: {
                return "secondary";
                break;
            }
        }
    }

    private getPriorityTotal(priority: number, nextEventGroup: TrackingBoard[]) {
        // 'text-danger': dataItem.minutesUntilDue <= 0
        // 'text-warning': dataItem.minutesUntilDue > 0 && dataItem.minutesUntilDue <= 15
        // 'text-primary': dataItem.minutesUntilDue > 15 && dataItem.minutesUntilDue <= 30
        // 'text-success': dataItem.minutesUntilDue > 30
        switch (priority) {
            case 1: {
                return nextEventGroup.filter(g => g.minutesUntilDue <= 0).length;
                break;
            }
            case 2: {
                return nextEventGroup.filter(g => g.minutesUntilDue > 0 && g.minutesUntilDue <= 15).length;
                break;
            }
            case 3: {
                return nextEventGroup.filter(g => g.minutesUntilDue > 15 && g.minutesUntilDue <= 30).length;
                break;
            }
            case 4: {
                return nextEventGroup.filter(g => g.minutesUntilDue > 30).length;
                break;
            }
            default: {
                return 0;
                break;
            }
        }
    }

    private getReferenceTypes() {
        this.orderService.getSearchReferenceTypesByRecordType("OrderStop").subscribe(result => {
            this.referenceTypeList = result.resultCollection;
        });
    }


    private updateTrackingGroupStatus() {
        this.trackingGroupStatus.forEach(s => {
            s.total = this.trackingBoard.filter(t => t.trackingPriority == s.priority).length;
            s.isShow = true;

            var nextEventGroup = this.trackingBoard.filter(t => t.trackingPriority == s.priority);
            var priorityList: TrackingGroupPriority[] = [];
            priorityList.push(this.setTrackingGroupPriority(1, nextEventGroup));
            priorityList.push(this.setTrackingGroupPriority(2, nextEventGroup));
            priorityList.push(this.setTrackingGroupPriority(3, nextEventGroup));
            priorityList.push(this.setTrackingGroupPriority(4, nextEventGroup));
            s.trackingGroupPriority = priorityList;
            if (this.getTrackingGroupPriority(1, priorityList)!.total > 0) {
                s.textColor = this.getStatusTextColor(1);
                s.backgroundColor = this.getStatusBackgroundColor(1);
            }
            else if (this.getTrackingGroupPriority(2, priorityList)!.total > 0) {
                s.textColor = this.getStatusTextColor(2);
                s.backgroundColor = this.getStatusBackgroundColor(2);
            }
            else if (this.getTrackingGroupPriority(3, priorityList)!.total > 0) {
                s.textColor = this.getStatusTextColor(3);
                s.backgroundColor = this.getStatusBackgroundColor(3);
            }
            else if (this.getTrackingGroupPriority(4, priorityList)!.total > 0) {
                s.textColor = this.getStatusTextColor(4);
                s.backgroundColor = this.getStatusBackgroundColor(4);
            }
            else {
                s.textColor = this.getStatusTextColor(0);
                s.backgroundColor = this.getStatusBackgroundColor(0);
            }
            //console.log("updateTrackingGroupStatus", s);
        });
    }

    private setTrackingGroupPriority(priority: number, nextEventGroup: TrackingBoard[]) {
        var trackingGroupPriority: TrackingGroupPriority = {
            priority: priority,
            textColor: this.getStatusTextColor(priority),
            backgroundColor: this.getStatusBackgroundColor(priority),
            total: this.getPriorityTotal(priority, nextEventGroup)
        };
        return trackingGroupPriority;
    }

    private getTrackingGroupPriority(priority: number, trackingGroupPriority: TrackingGroupPriority[]) {
        return trackingGroupPriority.find(t => t.priority = priority);
    }

    public filterTrackingGroupsChange(evt: any, status: TrackingGroup) {
        var trackingGroup = this.trackingGroupStatus.find(t => t.priority == status.priority);
        if (trackingGroup) {
            trackingGroup.isShow = evt.target.checked;
        }
        //console.log("filterTrackingGroupsChange", evt, trackingGroup, this.trackingGroupStatus);
        this.filterTrackingGroups();
    }

    private filterTrackingGroups() {
        this.trackingBoard.length = 0;
        this.trackingGroupStatus.forEach(s => {
            if (s.isShow == true) {
                var board = this.trackingBoardNextEvents.filter(t => t.trackingPriority == s.priority);
                this.trackingBoard = this.trackingBoard.concat(board);
                //console.log("filterTrackingGroups", s.isShow, board);
            }
        });
        var board = this.trackingBoardNextEvents.filter(t => t.trackingPriority == null);
        //console.log("filterTrackingGroups", board);
        this.trackingBoard = this.trackingBoard.concat(board);
        //console.log("filterTrackingGroups", this.trackingBoard);
        this.setTrackingBoardGrid();
        //this.filterChange(this.trackingBoardState.filter!);
    }

    public filterChange(filter: CompositeFilterDescriptor): void {
        //console.log("this.trackingBoardState.filter", this.trackingBoardState.filter, this.carrierRepsFilter);
        this.trackingBoardState.filter = filter;
        this.carrierRepsChange(this.carrierRepsFilter);
        this.accountManagersChange(this.accountManagersFilter);
        this.logisticSpecialistsChange(this.logisticSpecialistsFilter);
        this.tagTypesChange(this.tagTypesFilter);
        this.countryChange(this.originCountryFilter, "origin");
        this.countryChange(this.destinationCountryFilter, "destination");
        this.c2cChange(this.c2cFilter);
        //console.log("filterChange", filter, this.carrierRepsFilter);
        this.setTrackingBoardGrid();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.trackingGrid == null) return;
            this.trackingGrid.autoFitColumns();
        });
    }

    private fitScheduleColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.scheduleGrid == null) return;
            this.scheduleGrid.autoFitColumns();
        });
    }

    public carrierRepsChange(values: any[]): void {
        //console.log("carrierRepsChange", values);
        this.carrierRepsFilter = values;
        var valMap = values.map(value => ({
            field: "csr",
            operator: "eq",
            value
        }));
        var cf: CompositeFilterDescriptor = {
            filters: valMap,
            logic: "or"
        }

        if (!this.trackingBoardState.filter) {
            this.trackingBoardState.filter = {
                filters: [
                    {
                        filters: valMap,
                        logic: "or"
                    }
                ],
                logic: "and"
            };
        }
        else {
            var currFilters = this.trackingBoardState.filter.filters;
            //console.log("carrierRepsChange:currFilters before", currFilters);
            var idx = -1;
            currFilters.forEach(function (f: CompositeFilterDescriptor | FilterDescriptor, index) {
                var cf = f as CompositeFilterDescriptor;
                if (cf.filters) {
                    var fd = cf.filters[0] as FilterDescriptor;
                    if (fd.field == "csr") {
                        idx = index;
                    }
                    //console.log("carrierRepsChange:ComponsiteFilterDescriptor", cf.filters);
                }
            });
            // Remove the componsite filter if no other filters within the composite filter are in place
            if (idx >= 0) {
                currFilters.splice(idx, 1);
            }
            // Add the composite filter if value(s) selected
            if (values.length > 0) {
                currFilters.push(cf);
            }
            //console.log("carrierRepsChange:currFilters after", currFilters);
        }

        //console.log("carrierRepsChange:this.trackingBoardState.filter", this.trackingBoardState.filter, values, this.carrierRepsFilter);
        this.setTrackingBoardGrid();
    }

    public accountManagersChange(values: any[]): void {
        //console.log("accountManagersChange", values);
        this.accountManagersFilter = values;
        var valMap = values.map(value => ({
            field: "accountManager",
            operator: "eq",
            value
        }));
        var cf: CompositeFilterDescriptor = {
            filters: valMap,
            logic: "or"
        }

        if (!this.trackingBoardState.filter) {
            this.trackingBoardState.filter = {
                filters: [
                    {
                        filters: valMap,
                        logic: "or"
                    }
                ],
                logic: "and"
            };
        }
        else {
            var currFilters = this.trackingBoardState.filter.filters;
            //console.log("accountManagersChange:currFilters before", currFilters);
            var idx = -1;
            currFilters.forEach(function (f: CompositeFilterDescriptor | FilterDescriptor, index) {
                var cf = f as CompositeFilterDescriptor;
                if (cf.filters) {
                    var fd = cf.filters[0] as FilterDescriptor;
                    if (fd.field == "accountManager") {
                        idx = index;
                    }
                    //console.log("accountManagersChange:ComponsiteFilterDescriptor", cf.filters);
                }
            });
            // Remove the componsite filter if no other filters within the composite filter are in place
            if (idx >= 0) {
                currFilters.splice(idx, 1);
            }
            // Add the composite filter if value(s) selected
            if (values.length > 0) {
                currFilters.push(cf);
            }
            //console.log("accountManagersChange:currFilters after", currFilters);
        }

        //console.log("accountManagersChange:this.trackingBoardState.filter", this.trackingBoardState.filter, values, this.accountManagersFilter);
        this.setTrackingBoardGrid();
    }

    public logisticSpecialistsChange(values: any[]): void {
        //console.log("logisticSpecialistsChange", values);
        this.logisticSpecialistsFilter = values;
        var valMap = values.map(value => ({
            field: "logisticSpecialist",
            operator: "eq",
            value
        }));
        var cf: CompositeFilterDescriptor = {
            filters: valMap,
            logic: "or"
        }

        if (!this.trackingBoardState.filter) {
            this.trackingBoardState.filter = {
                filters: [
                    {
                        filters: valMap,
                        logic: "or"
                    }
                ],
                logic: "and"
            };
        }
        else {
            var currFilters = this.trackingBoardState.filter.filters;
            //console.log("logisticSpecialistsChange:currFilters before", currFilters);
            var idx = -1;
            currFilters.forEach(function (f: CompositeFilterDescriptor | FilterDescriptor, index) {
                var cf = f as CompositeFilterDescriptor;
                if (cf.filters) {
                    var fd = cf.filters[0] as FilterDescriptor;
                    if (fd.field == "logisticSpecialist") {
                        idx = index;
                    }
                    //console.log("logisticSpecialistsChange:ComponsiteFilterDescriptor", cf.filters);
                }
            });
            // Remove the componsite filter if no other filters within the composite filter are in place
            if (idx >= 0) {
                currFilters.splice(idx, 1);
            }
            // Add the composite filter if value(s) selected
            if (values.length > 0) {
                currFilters.push(cf);
            }
            //console.log("logisticSpecialistsChange:currFilters after", currFilters);
        }

        //console.log("logisticSpecialistsChange:this.trackingBoardState.filter", this.trackingBoardState.filter, values, this.logisticSpecialistsFilter);
        this.setTrackingBoardGrid();
    }

    public tagTypesChange(values: any[]): void {
        //console.log("tagTypesChange", values);
        this.tagTypesFilter = values;
        var valMapEquals = values.map(value => ({
            field: "tagTypes",
            operator: "eq",
            value
        }));
        var valMapStartsWith = values.map(value => ({
            field: "tagTypes",
            operator: "startswith",
            //function(value) { return value + ","; }
            value
        }));
        var valMapEndsWith = values.map(value => ({
            field: "tagTypes",
            operator: "endswith",
            //function(value) { return "," + value; }
            value
        }));
        var valMapContains = values.map(value => ({
            field: "tagTypes",
            operator: "contains",
            //function(value) { return "," + value + ","; }
            value
        }));
        var valMap = [...valMapEquals, ...valMapStartsWith, ...valMapEndsWith, ...valMapContains];
        //console.log("tagTypesChange:valMap", values, valMap);
        var cf: CompositeFilterDescriptor = {
            filters: valMap,
            logic: "or"
        }

        if (!this.trackingBoardState.filter) {
            this.trackingBoardState.filter = {
                filters: [
                    {
                        filters: valMap,
                        logic: "or"
                    }
                ],
                logic: "and"
            };
        }
        else {
            var currFilters = this.trackingBoardState.filter.filters;
            //console.log("tagTypesChange:currFilters before", currFilters);
            var idx = -1;
            currFilters.forEach(function (f: CompositeFilterDescriptor | FilterDescriptor, index) {
                var cf = f as CompositeFilterDescriptor;
                if (cf.filters) {
                    var fd = cf.filters[0] as FilterDescriptor;
                    if (fd.field == "tagTypes") {
                        idx = index;
                    }
                    //console.log("tagTypesChange:ComponsiteFilterDescriptor", cf.filters);
                }
            });
            // Remove the componsite filter if no other filters within the composite filter are in place
            if (idx >= 0) {
                currFilters.splice(idx, 1);
            }
            // Add the composite filter if value(s) selected
            if (values.length > 0) {
                currFilters.push(cf);
            }
            //console.log("tagTypesChange:currFilters after", currFilters);
        }

        //console.log("tagTypesChange:this.trackingBoardState.filter", this.trackingBoardState.filter, values, this.tagTypesFilter);
        this.setTrackingBoardGrid();
    }

    public countryChange(values: any[], type: string): void {
        //console.log("countryChange", values, type);
        var field: string = "";
        if (type == "origin") {
            this.originCountryFilter = values;
            field = "originCountryAbbreviation";
        }
        else if (type == "destination") {
            this.destinationCountryFilter = values;
            field = "destinationCountryAbbreviation";
        }
        var valMap = values.map(value => ({
            field: field,
            operator: "eq",
            value
        }));
        var cf: CompositeFilterDescriptor = {
            filters: valMap,
            logic: "or"
        }

        if (!this.trackingBoardState.filter) {
            this.trackingBoardState.filter = {
                filters: [
                    {
                        filters: valMap,
                        logic: "or"
                    }
                ],
                logic: "and"
            };
        }
        else {
            var currFilters = this.trackingBoardState.filter.filters;
            //console.log("countryChange:currFilters before", currFilters);
            var idx = -1;
            currFilters.forEach(function (f: CompositeFilterDescriptor | FilterDescriptor, index) {
                var cf = f as CompositeFilterDescriptor;
                if (cf.filters) {
                    //idx = index;
                    var fd = cf.filters[0] as FilterDescriptor;
                    if (fd.field == field) {
                        idx = index;
                    }
                    //console.log("countryChange:ComponsiteFilterDescriptor", cf.filters, field, idx);
                }
            });
            // Remove the componsite filter if no other filters within the composite filter are in place
            if (idx >= 0) {
                currFilters.splice(idx, 1);
            }
            // Add the composite filter if value(s) selected
            if (values.length > 0) {
                currFilters.push(cf);
            }
            //console.log("countryChange:currFilters after", currFilters);
        }

        //console.log("countryChange:this.trackingBoardState.filter", this.trackingBoardState.filter, values, this.originCountryFilter);
        this.setTrackingBoardGrid();
    }

    public c2cChange(values: any[]): void {
        //console.log("countryChange", values, type);
        var field: string = "legCntryToCntry";
        this.c2cFilter = values;
        var valMap = values.map(value => ({
            field: "legCntryToCntry",
            operator: "eq",
            value
        }));
        var cf: CompositeFilterDescriptor = {
            filters: valMap,
            logic: "or"
        }

        if (!this.trackingBoardState.filter) {
            this.trackingBoardState.filter = {
                filters: [
                    {
                        filters: valMap,
                        logic: "or"
                    }
                ],
                logic: "and"
            };
        }
        else {
            var currFilters = this.trackingBoardState.filter.filters;
            //console.log("countryChange:currFilters before", currFilters);
            var idx = -1;
            currFilters.forEach(function (f: CompositeFilterDescriptor | FilterDescriptor, index) {
                var cf = f as CompositeFilterDescriptor;
                if (cf.filters) {
                    //idx = index;
                    var fd = cf.filters[0] as FilterDescriptor;
                    if (fd.field == field) {
                        idx = index;
                    }
                    //console.log("countryChange:ComponsiteFilterDescriptor", cf.filters, field, idx);
                }
            });
            // Remove the componsite filter if no other filters within the composite filter are in place
            if (idx >= 0) {
                currFilters.splice(idx, 1);
            }
            // Add the composite filter if value(s) selected
            if (values.length > 0) {
                currFilters.push(cf);
            }
            //console.log("countryChange:currFilters after", currFilters);
        }

        //console.log("countryChange:this.trackingBoardState.filter", this.trackingBoardState.filter, values, this.originCountryFilter);
        this.setTrackingBoardGrid();
    }

    public carrierRepsFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
        //this.carrierRepsFilter.splice(0, this.carrierRepsFilter.length, ...flatten(filter).map(({ value }) => value));
        //console.log("carrierRepsFilters", filter, this.carrierRepsFilter);
        return this.carrierRepsFilter;
    }

    public accountManagersFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
        //this.accountManagersFilter.splice(0, this.accountManagersFilter.length, ...flatten(filter).map(({ value }) => value));
        //console.log("accountManagersFilters", filter, this.accountManagersFilter);
        return this.accountManagersFilter;
    }

    public logisticSpecialistsFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
        //this.logisticSpecialistsFilter.splice(0, this.logisticSpecialistsFilter.length, ...flatten(filter).map(({ value }) => value));
        //console.log("logisticSpecialistsFilters", filter, this.logisticSpecialistsFilter);
        return this.logisticSpecialistsFilter;
    }

    public tagTypesFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
        //console.log("tagTypesFilters", filter, this.tagTypesFilter);
        return this.tagTypesFilter;
    }

    public countryFilters(filter: CompositeFilterDescriptor, type: string): FilterDescriptor[] {
        if (type == "origin") {
            return this.originCountryFilter;
        }
        else if (type == "destination") {
            return this.destinationCountryFilter;
        }
        else {
            return [];
        }
    }

    public c2cFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
        return this.c2cFilter;
    }

    private getEmployeeInfo() {
        //this.isLoading = true;
        this.employeeService.getEmployeeById(this.quoteOrderLine!.awardedCarrierRepId).subscribe(result => {
            //this.isLoading = false;
            this.carrierRep = result == null ? {} as Employee : result;
        });
    }

    private getSearchOrderEventTypes() {
        this.isLoading = true;
        this.orderService.getGetAllSearchOrderEventType().subscribe(result => {
            this.isLoading = false;
            this.searchOrderEventTypes = result;

            var checkCallCodes = this.searchOrderEventTypes.filter(c => c.eventTypeName == "Check Call");
            checkCallCodes = checkCallCodes.sort((left, right): number => {
                if (left.code < right.code) return -1;
                if (left.code > right.code) return 1;
                return 0;
            });
            this.checkCallEventTypes = checkCallCodes;

            var scheduleViewCodes = this.searchOrderEventTypes.filter(c => c.eventTypeName == "Non-Stop Order Event" && c.code != "PPC" && c.code != "LTE");
            scheduleViewCodes = scheduleViewCodes.sort((left, right): number => {
                if (left.code < right.code) return -1;
                if (left.code > right.code) return 1;
                return 0;
            });
            this.scheduleViewEventTypes = scheduleViewCodes;

            var ppcCode = this.searchOrderEventTypes.filter(c => c.code == "PPC");
            this.ppcViewEventType = ppcCode;

            var scheduleCodes = this.searchOrderEventTypes.filter(c => c.eventTypeName == "Non-Stop Order Event");
            scheduleCodes = scheduleCodes.sort((left, right): number => {
                if (left.code < right.code) return -1;
                if (left.code > right.code) return 1;
                return 0;
            });
            this.scheduleEventTypes = scheduleCodes;

            var trackingCodes = this.searchOrderEventTypes.filter(c => c.eventTypeName == "Tracking");
            trackingCodes = trackingCodes.sort((left, right): number => {
                if (left.code < right.code) return -1;
                if (left.code > right.code) return 1;
                return 0;
            });
            this.trackingEventTypes = trackingCodes;

            var addMultipleCodes = this.searchOrderEventTypes.filter(c => c.eventTypeName == "Non-Stop Order Event" && (c.code == "MM" || c.code == "CLR"));
            addMultipleCodes = addMultipleCodes.sort((left, right): number => {
                if (left.code < right.code) return -1;
                if (left.code > right.code) return 1;
                return 0;
            });
            this.addMultipleEventTypes = addMultipleCodes;
        });
    }

    public getEventCode(orderEventTypeID: number) {
        var eventType = this.searchOrderEventTypes.find(t => t.orderEventTypeID == orderEventTypeID);
        if (eventType != null) {
            return eventType.code;
        }
        else {
            return "";
        }
    }

    public getIsNonStopOrderEvent(code: string) {
        var idx = this.scheduleEventTypes.findIndex(c => c.code == code);
        //console.log("getIsNonStopOrderEvent", idx, code);
        if (idx == null || idx < 0) {
            return false;
        }
        else {
            return true;
        }
    }

    private getSearchQuoteOrderLine(quoteOrderID: number, quoteOrderLineID: number) {
        //this.isLoading = true;
        this.orderService.getSearchQuoteOrderLinesByQuoteOrderID(quoteOrderID).subscribe(result => {
            //this.isLoading = false;
            this.searchLineList = result.resultCollection;
            if (result.resultCollection.length > 0) {
                var line = this.searchLineList.find(t => t.quoteOrderLineID == quoteOrderLineID);
                if (line != null) {
                    this.searchLine = line;
                }
                else {
                    this.searchLine = {} as SearchQuoteOrderLine;
                }
            }
            else {
                this.searchLine = {} as SearchQuoteOrderLine;
            }
            this.checkPreviousLegComplete();
            this.getStops(false);
        });
    }

    private getQuoteOrder(quoteOrderID: number) {
        //this.isLoading = true;
        this.orderService.getQuoteOrderByID(quoteOrderID).subscribe(result => {
            //this.isLoading = false;
            this.quoteOrder = result.resultCollection[0];
            this.getSearchCustomer(this.quoteOrder.customerID);
        });
    }

    private getQuoteOrderLine(lineId: number) {
        //this.isLoading = true;
        this.orderService.getQuoteOrderLineById(lineId).subscribe(result => {
            //this.isLoading = false;
            this.quoteOrderLine = result;

            this.getEmployeeInfo();
        });
    }

    private getSearchCustomer(customerID: number) {
        this.crmService.getSearchCustomerByID(customerID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.searchCustomer = result.resultCollection[0];
            }
        });
    }

    public getMacropointUrl(board: TrackingBoard) {
        this.isLoading = true;
        this.erpService.getMacropointLink(board.quoteOrderLineId).subscribe(result => {
            this.isLoading = false;
            var url = result.resultCollection[0];
            if (url == "") {
                this.macropointURL = "";
                this.notificationService.showWarning("System failed to retrieve link from Macropoint. Please make sure this load is setup in their system.", "WARNING: Macropoint Link");
            }
            else {
                this.macropointURL = url;
                window.open(url, "_blank");
            }
        });
        // this.orderService.getMacropointUrlByLineId(board.quoteOrderLineId).subscribe(result => {
        //     this.isLoading = false;
        //     if (result.length > 0) {
        //         this.macropointURL = result;
        //         window.open(this.macropointURL, "_blank");
        //     }
        //     else {
        //         this.macropointURL = "";
        //         this.notificationService.showWarning("Macropoint URL not found.", "Warning: Macropoint URL");
        //     }
        //     //console.log("macropointURL", this.macropointURL);
        // });
    }

    private getPiecesUnit(unitOfMeasureId: number): string {
        var unit = this.pieceUnits.find(u => u.unitOfMeasureId == unitOfMeasureId);
        return unit == null ? '' : unit.code;
    }

    private getWeightUnit(unitOfMeasureId: number): string {
        var unit = this.weightUnits.find(u => u.unitOfMeasureId == unitOfMeasureId);
        return unit == null ? '' : unit.code;
    }

    public checkPieces(sched: OrderEventSchedule) {
        if (sched.orderStop.pieces > 1000000) {
            sched.orderStop.pieces = 1000000;
        }
        if (sched.orderStop.pieces < 0) {
            sched.orderStop.pieces = 0;
        }
    }

    public checkWeight(sched: OrderEventSchedule) {
        if (sched.orderStop.weight > 1000000) {
            sched.orderStop.weight = 1000000;
        }
        if (sched.orderStop.weight < 0) {
            sched.orderStop.weight = 0;
        }
    }

    public setNumRecords(numRecords: number) {
        this.numRecords = numRecords;
        this.getTrackingBoard({} as TrackingBoard);
    }

    private getTrackingBoard(board: TrackingBoard) {
        // Clear the orders list for data refresh
        this.trackingBoard.length = 0;

        this.trackingBoardState.sort = [
            //{
            //    field: "orderNumber",
            //    dir: "desc"
            //},
            {
                field: "trackingPriority",
                dir: "asc"
            },
            {
                field: "orderEventDateUTC",
                dir: "asc"
            },
            {
                field: "orderEventSequence",
                dir: "asc"
            }
        ];

        this.isTrackingBoardLoading = true;
        //getTrackingBoardNextEvent
        //getTrackingBoardNextEventDS
        //getSearchTrackingBoardNextEvent
        this.orderService.getSearchTrackingBoardNextEventTopResults(this.numRecords).subscribe(result => {
            var board = result.resultCollection.sort((left, right): number => {
                if (left.quoteOrderLineId < right.quoteOrderLineId) return -1;
                if (left.quoteOrderLineId > right.quoteOrderLineId) return 1;
                return 0;
            });

            board.forEach(s => {
                s.orderEventDate = new Date(s.orderEventDate);
                //s.orderEventDate = new Date(s.orderEventDate + "Z");
                if (s.orderEventDateUTC != null) {
                    s.orderEventDateUTC = new Date(s.orderEventDateUTC + "Z");
                }
                else {
                    s.orderEventDateUTC = s.orderEventDate;
                }
            });

            //this.trackingBoardAll = Object.assign([], board);
            this.trackingBoard = Object.assign([], board);

            //// Get unique quoteOrderLineId list from result
            //var quoteOrderLineIdList = [... new Set(board.map(item => item.quoteOrderLineId))];
            //quoteOrderLineIdList.forEach((item, index) => {
            //    var orders = board.filter(b => b.quoteOrderLineId == item);
            //    //var earliestEvent = orders.reduce((a, b) => (a.orderEventDate < b.orderEventDate ? a : b));
            //    var earliestEvent = orders.reduce((a, b) => (a.orderEventSequence < b.orderEventSequence ? a : b));
            //    //earliestEvent.trackingBoardDetail = orders;

            //    var idx = -1;
            //    idx = this.trackingBoard.findIndex(t => t.quoteOrderLineId == earliestEvent.quoteOrderLineId);
            //    if (idx == null || idx < 0) this.trackingBoard.push(earliestEvent);
            //});

            this.trackingBoardNextEvents = Object.assign([], this.trackingBoard);
            this.getCountries();
            this.getC2CList();
            this.updateTrackingGroupStatus();
            this.isTrackingBoardLoading = false;
            this.setTrackingBoardGrid();
        });
    }

    public onGridDetailExpand(evt: any) {
        //console.log("onGridDetailExpand", evt);
        this.getTrackingBoardDetail(evt.dataItem);
    }

    private getTrackingBoardDetail(trackingBoard: TrackingBoard) {
        this.isTrackingBoardLoading = true;
        this.orderService.getSearchTrackingBoardNotCompletedByQuoteOrderID(trackingBoard.quoteOrderID).subscribe(result => {
            this.isTrackingBoardLoading = false;

            var board = result.resultCollection.sort((left, right): number => {
                if (left.orderEventSequence < right.orderEventSequence) return -1;
                if (left.orderEventSequence > right.orderEventSequence) return 1;
                return 0;
            });

            board.forEach(s => {
                s.orderEventDate = new Date(s.orderEventDate);
                //s.orderEventDate = new Date(s.orderEventDate + "Z");
                if (s.orderEventDateUTC != null) {
                    s.orderEventDateUTC = new Date(s.orderEventDateUTC + "Z");
                }
                else {
                    s.orderEventDateUTC = s.orderEventDate;
                }
            });

            var quoteOrderLineIdList = [... new Set(board.map(item => item.quoteOrderLineId))];
            quoteOrderLineIdList.forEach((item, index) => {
                var orders = board.filter(b => b.quoteOrderLineId == item);

                var idx = -1;
                idx = this.trackingBoard.findIndex(t => t.orderEventScheduleId == trackingBoard.orderEventScheduleId);
                this.trackingBoard[idx].trackingBoardDetail = orders;
            });

            this.setTrackingBoardGrid();
        });
    }

    private setTrackingBoardGrid() {
        var board = this.trackingBoard.slice();

        if (this.trackingBoardState.filter) board = filterBy(board, this.trackingBoardState.filter);
        if (this.trackingBoardState.sort) board = orderBy(board, this.trackingBoardState.sort);

        this.trackingBoardView = process(board, this.trackingBoardState);
        this.fitColumns();
        //console.log("setTrackingBoardGrid", this.trackingBoard, this.trackingBoardView);
    }

    //private getTrackingBoardDetail(dataItem: TrackingBoard) {
    //    if (dataItem.quoteOrderLineId) {
    //        var board = this.trackingBoard.filter(t => t.quoteOrderLineId == dataItem.quoteOrderLineId).slice();
    //        board = orderBy(board, [{ field: "orderEventDate", dir: "asc" }]);
    //        return process(board, this.trackingBoardState);
    //    }
    //}

    private getOrderEventScheduleView() {
        if (this.quoteOrderLineID > 0) {
            this.isScheduleLoading = true;
            this.orderService.getOrderEventScheduleViewByQuoteOrderLineId(this.quoteOrderLineID).subscribe(result => {
                this.isSelectedRowLoading = false;
                this.isScheduleLoading = false;
                this.orderEventScheduleView = result.resultCollection.sort((left, right): number => {
                    if (left.orderEventSequence < right.orderEventSequence) return -1;
                    if (left.orderEventSequence > right.orderEventSequence) return 1;
                    return 0;
                });
                this.orderEventScheduleView.forEach(s => {
                    //console.log("getOrderEventScheduleView:before", s.orderEventDate, s.orderEventDateUTC);
                    s.orderEventDate = new Date(s.orderEventDate);
                    //s.orderEventDate = new Date(s.orderEventDate + "Z");
                    if (s.orderEventDateUTC != null) {
                        s.orderEventDateUTC = new Date(s.orderEventDateUTC + "Z");
                    }
                    else {
                        s.orderEventDateUTC = s.orderEventDate;
                    }
                    if (s.completedDate != null) {
                        s.completedDate = new Date(s.completedDate + "Z");
                    }
                    //console.log("getOrderEventScheduleView:after", s.orderEventDate, s.orderEventDateUTC);
                });
                this.scheduleViewState.skip = 0;
                this.setScheduleGrid();
                this.checkAllTrackingComplete();
                //this.stepper.next();
            });
        }
    }

    private setScheduleProgress() {
        this.orderEventProgress.length = 0;
        var schedList: OrderEventSchedule[] = this.fullOrderEventSchedule.filter(o => o.cancelled != true);
        var max = schedList.length;
        var step = Math.floor(100 / max);
        //var header = "";
        //var body = "";
        //var footer = "";
        var label = "";
        var prevStop = "";
        var currStop = "";
        var value = 0;
        var color = "";

        for (var i = 0; i < max; i++) {
            //console.log(schedList[i]);
            var stop = (schedList[i].orderStop != undefined ? schedList[i].orderStop : null);
            if (stop) {
                var searchStop = this.searchOrderStops.find(t => t.orderStopID == stop!.orderStopId);
                if (searchStop != null) {
                    label = searchStop.cityName + ',' + searchStop.stAbbr;
                }
                //label = (stop.city == null ? '' : stop.city.cityST);
                currStop = label;
            }
            else {
                currStop = "";
            }
            if (currStop.toLowerCase() == prevStop.toLowerCase()) {
                label = "";
                //header = "";
                //body = "";
            }
            if (i == max - 1) {
                value = step + (100 - step * max);
            }
            else {
                value = step;
            }
            if (schedList[i].completed) {
                color = "bg-success";
            }
            else {
                color = "";
            }
            this.orderEventProgress.push({
                //header: header,
                //body: body,
                //footer: footer,
                label: label,
                value: value,
                color: color
            });
            prevStop = currStop;
        }
    }

    private getLocalTime(value: Date) {
        var hourOffset: number = 0;
        if (value.toString().indexOf("Central") > 0) {
            hourOffset = 1;
        }
        else if (value.toString().indexOf("Mountain") > 0 || value.toString().indexOf("Arizona") > 0) {
            hourOffset = 2;
        }
        else if (value.toString().indexOf("Pacific") > 0) {
            hourOffset = 3;
        }
        var ret: Date = new Date(value.getTime() + hourOffset * 60 * 60000);
        return ret;
    }

    private getOrderEventSchedule(lineId) {
        this.isTrackingEventLoading = true;
        this.orderService.getOrderEventScheduleByQuoteOrderLineId(lineId).subscribe(result => {
            this.isTrackingEventLoading = false;
            this.orderEventSchedule = result.resultCollection;
            this.setOrderEventScheduleFields();
        });
        this.getQuoteOrderLine(lineId);
    }

    private setOrderEventScheduleFields() {
        this.orderEventSchedule = this.orderEventSchedule.sort((left, right): number => {
            if (left.orderEventSequence < right.orderEventSequence) return -1;
            if (left.orderEventSequence > right.orderEventSequence) return 1;
            return 0;
        });

        this.orderEventSchedule.forEach(s => {
            //console.log("orderEventSchedule", s.orderEventDate, new Date(s.orderEventDate), s);
            var code = this.getEventCode(s.orderEventTypeID);
            s.orderEventDate = new Date(s.orderEventDate);
            if (s.orderEventDateUTC != null) {
                s.orderEventDateUTC = new Date(s.orderEventDateUTC + "Z");
            }
            else {
                s.orderEventDateUTC = s.orderEventDate;
            }
            if (s.nextETADate != null) {
                s.nextETADate = new Date(s.nextETADate);
            }
            if (s.nextETADateUTC != null) {
                s.nextETADateUTC = new Date(s.nextETADateUTC + "Z");
            }
            s.completedDate = new Date(s.completedDate);
            s.code = code;
            s.orderStop = Object.assign({}, this.getOrderStop(s.orderStopID)!);
            s.isNonStopOrderEvent = this.getIsNonStopOrderEvent(code);
            // This line must come after s.isNonStopOrderEvent
            s.isRefreshNeeded = this.checkRefreshNeeded(s);
        });

        this.fullOrderEventSchedule = JSON.parse(JSON.stringify(this.orderEventSchedule));
        this.fullOrderEventSchedule.forEach(s => {
            //console.log("orderEventSchedule", s.orderEventDate, new Date(s.orderEventDate), s);
            s.orderEventDate = new Date(s.orderEventDate);
            if (s.orderEventDateUTC != null) {
                s.orderEventDateUTC = new Date(s.orderEventDateUTC);
            }
            else {
                s.orderEventDateUTC = s.orderEventDate;
            }
            if (s.nextETADate != null) {
                s.nextETADate = new Date(s.nextETADate);
            }
            if (s.nextETADateUTC != null) {
                s.nextETADateUTC = new Date(s.nextETADateUTC);
            }
            s.completedDate = new Date(s.completedDate);
        });

        this.orderEventSchedule = this.orderEventSchedule.filter(s => s.completed != true);

        if (this.orderEventSchedule.length > 10) {
            this.orderEventSchedule.length = 10;
        }

        if (this.orderEventSchedule.length > 0) {
            this.orderEventSequenceMin = this.orderEventSchedule[0].orderEventSequence;
            this.orderEventSequenceMax = this.orderEventSchedule[this.orderEventSchedule.length - 1].orderEventSequence;
        }

        this.currentOrderEventSchedule = JSON.parse(JSON.stringify(this.orderEventSchedule[0]));

        if (this.currentOrderEventSchedule.code == "LTE" && this.quoteOrderLine.macropointOrderId > 0) {
            this.isMacropointLTE = true;
            this.getExcludeLTE();
        }

        this.setScheduleProgress();
    }

    private checkRefreshNeeded(sched: OrderEventSchedule) {
        var isValid = true;
        //console.log("checkRefreshNeeded", sched.code, sched, sched.orderStop);
        if (!sched.isNonStopOrderEvent) {
            if (sched.orderStop == undefined) {
                isValid = false;
            }
            else if (sched.completed == true && sched.code.indexOf("-Arv") > 0 && sched.orderStop.arrivedInd != true) {
                isValid = false;
            }
            else if (sched.completed == true && sched.code.indexOf("-Dep") > 0 && sched.orderStop.departedInd != true) {
                isValid = false;
            }
            else if (sched.completed != true && sched.code.indexOf("-Arv") > 0 && sched.orderStop.arrivedInd == true) {
                isValid = false;
            }
            else if (sched.completed != true && sched.code.indexOf("-Dep") > 0 && sched.orderStop.departedInd == true) {
                isValid = false;
            }
        }
        return !isValid;
    }

    private checkPreviousLegComplete() {
        // Check if previous leg in multi-leg order is complete.
        // Do not allow management, except for PPC, if previous leg is not complete
        //var thisBoard = this.trackingBoardAll.find(t => t.quoteOrderLineId == this.quoteOrderLineID);
        //var quoteOrderID = thisBoard!.quoteOrderID;
        //var legNumber = thisBoard!.legNumber;
        //this.isPreviousLegComplete = true;
        //if (legNumber > 1) {
        //    var prevLegNotComplete = this.trackingBoardAll.filter(t => t.quoteOrderID == quoteOrderID && t.completed != true && t.legNumber == legNumber - 1);
        //    if (prevLegNotComplete.length > 0) {
        //        this.isPreviousLegComplete = false;
        //    }
        //}
        if (this.searchLine.legNumber > 1) {
            var prevLine = this.searchLineList.find(t => t.carrierID > 0 && t.loadStatus == "Completed" && t.legNumber == this.searchLine.legNumber - 1);
            if (prevLine != null) {
                this.isPreviousLegComplete = true;
            }
            else {
                this.isPreviousLegComplete = false;
            }
        }
        else {
            this.isPreviousLegComplete = true;
        }
        //console.log("checkPreviousLegComplete", this.isPreviousLegComplete, this.searchLine);
    }

    private checkNextLegOverlap() {
        // Check if current leg in multi-leg order overlaps the next leg.
        // Do not allow TMW update until correction is made to stops or in TMW
        var lastStop = this.orderStops[this.orderStops.length - 1];
        if (lastStop) {
            var thisBoard = this.trackingBoardNextEvents.find(t => t.quoteOrderLineId == lastStop.quoteOrderLineId);
            var quoteOrderID = thisBoard!.quoteOrderID;
            var legNumber = thisBoard!.legNumber;
            this.isNextLegOverlap = false;

            this.isTrackingBoardLoading = true;
            this.orderService.getSearchTrackingBoardNotCompletedByQuoteOrderID(quoteOrderID).subscribe(result => {
                this.isTrackingBoardLoading = false;

                var nextLegEvents = result.resultCollection.filter(t => t.legNumber == legNumber + 1 && t.completed != true && t.orderStopId > 0);
                nextLegEvents = nextLegEvents.sort((left, right): number => {
                    if (left.orderEventSequence < right.orderEventSequence) return -1;
                    if (left.orderEventSequence > right.orderEventSequence) return 1;
                    return 0;
                });

                nextLegEvents.forEach(b => {
                    b.orderEventDate = new Date(b.orderEventDate);
                    if (b.orderEventDateUTC != null) {
                        b.orderEventDateUTC = new Date(b.orderEventDateUTC + "Z");
                    }
                    else {
                        b.orderEventDateUTC = b.orderEventDate;
                    }
                });
                var nextLegOverlapStops = nextLegEvents.filter(t =>
                    t.orderEventDate < lastStop.departDate
                );
                if (nextLegOverlapStops.length > 0) {
                    this.isNextLegOverlap = true;
                }
                console.log("checkNextLegOverlap", nextLegEvents, lastStop, nextLegOverlapStops, this.isNextLegOverlap);
            });
        }
    }

    public isSetDayBack(sched: OrderEventSchedule) {
        var ret: boolean = false;
        if (this.isSetDayBackClicked != true) {
            var prevStopEventList = this.fullOrderEventSchedule.filter(t => t.orderEventSequence < sched.orderEventSequence && t.orderStopID > 0);
            var prevStopEvent: OrderEventSchedule = {} as OrderEventSchedule;
            if (prevStopEventList.length > 0) {
                prevStopEvent = prevStopEventList[prevStopEventList.length - 1];
            }
            if (prevStopEvent.orderStopID) {
                var prevDate: Date = new Date(prevStopEvent.orderEventDate);
                var thisDate: Date = new Date(sched.orderEventDate);
                if (prevDate.getDate() != thisDate.getDate()) {
                    ret = true;
                }
            }
        }
        return ret;
    }

    public setDayBack(sched: OrderEventSchedule) {
        var prevStopEventList = this.fullOrderEventSchedule.filter(t => t.orderEventSequence < sched.orderEventSequence && t.orderStopID > 0);
        var prevStopEvent: OrderEventSchedule = {} as OrderEventSchedule;
        if (prevStopEventList.length > 0) {
            prevStopEvent = prevStopEventList[prevStopEventList.length - 1];
        }
        if (prevStopEvent.orderStopID) {
            var prevDate: Date = new Date(prevStopEvent.orderEventDate);
            var thisDate: Date = new Date(sched.orderEventDate);
            var thisNewDate: Date = this.utilService.addDays(thisDate, -1);
            if (thisNewDate <= prevDate) {
                thisNewDate = this.utilService.addMinutes(prevDate, 1);
            }
            sched.orderEventDate = thisNewDate;
        }
        this.isSetDayBackClicked = true;
    }

    stepperSelectionChange(evt: any) {
        //console.log("stepperSelectionChange", evt);
        this.isCheckCall = false;
    }

    private getStops(isSilent: boolean) {
        if (this.quoteOrderLineID > 0) {
            this.isLoading = true && !isSilent;
            this.orderService.getStopsByQuoteOrderID(this.searchLine.quoteOrderID).subscribe(result => {
                this.isLoading = false;
                this.isRemainOpenAfterSave = false;

                this.getSearchOrderStops();

                this.quoteOrderStops = result.resultCollection.sort((left, right): number => {
                    if (left.stopSequence < right.stopSequence) return -1;
                    if (left.stopSequence > right.stopSequence) return 1;
                    return 0;
                });

                this.quoteOrderStops.forEach(s => {
                    s.earliestDate = new Date(s.earliestDate);
                    s.latestDate = new Date(s.latestDate);
                    s.arrivalDate = new Date(s.arrivalDate);
                    s.departDate = new Date(s.departDate);

                    // Check if any LLD-Dep is completed but pieces/weight not confirmed
                    if (s.eventCode == "LLD" && s.departedInd == true && s.confirmedFreight != true) {
                        this.isLLDDepartedNotConfirmed = true;
                    }
                });

                this.orderStops = this.quoteOrderStops.filter(t => t.quoteOrderLineId == this.quoteOrderLineID);

                this.checkNextLegOverlap();
                if (this.isNextLegOverlap) {
                    //this.notificationService.showWarning("TMW not updated: stop overlaps with next order leg.", "WARNING: TMW Update");
                    this.notificationService.showWarning("Overlap: stop overlaps with next order leg.", "WARNING: Stop Update");
                }

                if (this.searchLine.externalOrderNumber != null && this.searchLine.externalOrderNumber != "") {
                    // Update TMW if changes found
                    //this.updateTMW(this.quoteOrderLineID);
                    //this.updateERPByQuoteOrderLineID(this.quoteOrderLineID);

                    //if (tmwOrderStops.length > 0 && !this.isNextLegOverlap) {
                    //if (tmwOrderStops.length > 0) {
                    //    this.notificationService.showInfo("Updating TMW Stops ...", "TMW Update");
                    //    this.orderService.updateTMW(tmwOrderStops).subscribe(result => {
                    //        var ok = result;
                    //        if (result.message != "OK") {
                    //            this.notificationService.showError("Error updating TMW: " + result.message, "ERROR: TMW Update");
                    //        }
                    //        else {
                    //            this.notificationService.showInfo("TMW Update Complete", "TMW Update");
                    //        }
                    //    });
                    //}
                }

                if (!isSilent) {
                    this.getOrderStopCommodities(this.quoteOrderLineID);
                    //this.setStopMarkers();
                    //this.getSearchMacropointStopAlerts();
                    this.getOrderEventSchedule(this.quoteOrderLineID);
                }
            });
        }
    }

    private getSearchOrderStops() {
        this.orderService.getSearchOrderStopsByQuoteOrderID(this.searchLine.quoteOrderID).subscribe(result => {
            this.searchOrderStops = result.resultCollection;
        });
    }

    private getSearchOrderStop(stopID: number) {
        var stop = this.searchOrderStops.find(t => t.orderStopID == stopID);
        return stop;
    }

    private getOrderStopCommodities(lineId: number) {
        //this.isLoading = true;
        if (lineId > 0) {
            this.orderService.getSearchOrderStopCommodityByLineId(lineId).subscribe(result => {
                //this.isLoading = false;
                this.orderStops.forEach(s => {
                    var commodity = result.resultCollection.find(c => c.orderStopId == s.orderStopId);
                    s.commodity = commodity!;
                });
            });
        }
    }

    private getOrderStop(orderStopId: number) {
        return this.orderStops.find(s => s.orderStopId == orderStopId);
    }

    //private getCheckCalls(quoteOrderLineID: number) {
    //    this.orderService.getSearchCheckCallByQuoteOrderLineID(quoteOrderLineID, "").subscribe(result => {
    //        this.checkCalls = result.resultCollection;
    //    });
    //}

    private getReferenceNumbers(quoteOrderID: number) {
        //this.isLoading = true;
        this.orderService.getSearchReferenceNumbersByQuoteOrderID(quoteOrderID).subscribe(result => {
            //this.isLoading = false;
            this.referenceNumbers = result.resultCollection;
        });
    }

    private getSearchMacropointStopAlerts() {
        var futureStops = this.orderStops.filter(s => s.arrivalDate > new Date());
        //console.log("OrderStopId", board.orderStopId, this.orderStop);
        if (futureStops.length > 0) {
            var orderStopID: number = futureStops[0].orderStopId;
            //this.isLoading = true;
            this.orderService.getSearchMacropointStopAlertHistoryByOrderStopID(orderStopID).subscribe(result => {
                //this.isLoading = false;
                this.stopAlerts = result.resultCollection;
            });
        }
    }

    private setScheduleGrid() {
        if (this.scheduleViewState.sort) {
            this.orderEventScheduleView = orderBy(this.orderEventScheduleView, this.scheduleViewState.sort);
        }

        this.scheduleView = process(this.orderEventScheduleView, this.scheduleViewState);

        this.fitScheduleColumns();
    }

    public scheduleViewStateChange(state: DataStateChangeEvent): void {
        this.scheduleViewState = state;
        this.setScheduleGrid();
    }

    public resetScheduleClick() {
        this.recordLockAction = "resetScheduleClick";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    private allowResetScheduleClick() {
        this.isLoading = true;
        this.orderService.orderEventScheduleResetByQuoteOrderLineID(this.selectedTrackingBoard.quoteOrderLineId).subscribe(result => {
            this.isLoading = false;
            var ok = result;
            //console.log("recreateScheduleClick", ok);
            this.orderEventSchedule = result.resultCollection;
            this.setOrderEventScheduleFields();
            if (result.message != "OK") {
                this.notificationService.showError("Error resetting schedule: " + result.message, "ERROR: Reset Tracking Schedule");
            }
            this.isRemainOpenAfterSave = true;
            this.refreshViews(this.currentOrderEventSchedule!);
            //this.refreshViews(this.orderEventSchedule[0]);
        });
    }

    public recreateScheduleClick(evt: any, sched: OrderEventSchedule) {
        this.recordLockHandleEvent = evt;
        this.recordLockHandleSchedule = sched;
        this.recordLockAction = "recreateScheduleClick";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    private allowRecreateScheduleClick(evt: any, sched: OrderEventSchedule) {
        this.recordLockHandleEvent = undefined;
        this.recordLockHandleSchedule = {} as OrderEventSchedule;
        this.isLoading = true;
        this.orderService.setOrderEventScheduleViewByQuoteOrderLineId(sched.quoteOrderLineID).subscribe(result => {
            this.isLoading = false;
            var ok = result;
            //console.log("recreateScheduleClick", ok);
            this.orderEventSchedule = result.resultCollection;
            this.setOrderEventScheduleFields();
            if (result.message != "OK") {
                this.notificationService.showError("Error refreshing schedule: " + result.message, "ERROR: Refresh Tracking Schedule");
            }
            this.refreshViews(sched);
        });
    }

    public isValidUrl(url: string) {
        this.isValidExternalTrackingLink = this.utilService.isValidURL(url);
    }

    public saveSearchQuoteOrderLine() {
        this.recordLockAction = "saveSearchQuoteOrderLine";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    public allowSaveSearchQuoteOrderLine() {
        this.isLoading = true;
        this.quoteOrder.lastModifiedByEmployeeID = this.utilService.getEmployeeID();

        console.log("saveSearchQuoteOrderLine", "quoteOrderLine", this.searchLine);

        this.orderService.saveLineFromSearchQuoteOrderLine(this.searchLine).subscribe(result => {
            this.isLoading = false;
            if (result.resultCollection.length > 0) {
                var updatedLine: SearchQuoteOrderLine = result.resultCollection[0];
                console.log("saveSearchQuoteOrderLine", "updatedLine", updatedLine);
            }
            else {
                this.notificationService.showError("Error saving external tracking link (no results)", "ERROR: Save External Tracking Link");
            }
        });
    }

    public saveOrder() {
        this.recordLockAction = "saveOrder";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    private allowSaveOrder() {
        this.isLoading = true;
        this.quoteOrder.lastModifiedByEmployeeID = this.utilService.getEmployeeID();

        console.log("saveOrder", "quoteOrder", this.quoteOrder);

        this.orderService.saveQuoteOrder(this.quoteOrder).subscribe(result => {
            this.isLoading = false;
            if (result.resultCollection.length > 0) {
                var updatedOrder: QuoteOrder = result.resultCollection[0];
                console.log("saveOrder", "updatedOrder", updatedOrder);
            }
            else {
                this.notificationService.showError("Error saving notes (no results)", "ERROR: Save Notes");
            }
        });
    }

    private getExcludeLTE() {
        this.orderService.getLatestQuoteOrderLineOrderEventExclude(this.currentOrderEventSchedule.quoteOrderLineID, this.currentOrderEventSchedule.orderEventTypeID).subscribe(result => {
            this.isExcludeLTE = true;
            if (result.resultCollection.length > 0) {
                this.excludeLTE = result.resultCollection[0];
                if (this.excludeLTE.releasedDate == null) {
                    this.isExcludeLTE = false;
                }
                else {
                    this.excludeLTE = {} as QuoteOrderLineOrderEventExclude;
                    this.excludeLTE.quoteOrderLineOrderEventExcludeID = 0;
                    this.excludeLTE.quoteOrderLineID = this.currentOrderEventSchedule.quoteOrderLineID;
                    this.excludeLTE.orderEventTypeID = this.currentOrderEventSchedule.orderEventTypeID;
                }
            }
            else {
                this.excludeLTE.quoteOrderLineOrderEventExcludeID = 0;
                this.excludeLTE.quoteOrderLineID = this.currentOrderEventSchedule.quoteOrderLineID;
                this.excludeLTE.orderEventTypeID = this.currentOrderEventSchedule.orderEventTypeID;
            }
            if (this.excludeLTE.notes == null) {
                this.excludeLTE.notes = "";
            }
        });
    }

    public includeLTEClick() {
        this.isExcludeLTEClicked = true;
    }

    public excludeLTEClick() {
        this.isExcludeLTEClicked = true;
    }

    public saveExcludeLTE() {
        if (this.isExcludeLTE) {
            this.excludeLTE.createdByEmployeeID = this.utilService.getEmployeeID();
            this.utilService.isLoading = true;
            this.orderService.saveQuoteOrderLineOrderEventExclude(this.excludeLTE).subscribe(result => {
                this.utilService.isLoading = false;
                this.isExcludeLTEClicked = false;
                this.getExcludeLTE();
            });
        }
        else {
            if (this.excludeLTE && this.excludeLTE.releasedDate == null) {
                this.excludeLTE.releasedByEmployeeID = this.utilService.getEmployeeID();
                this.utilService.isLoading = true;
                this.orderService.saveQuoteOrderLineOrderEventExclude(this.excludeLTE).subscribe(result => {
                    this.utilService.isLoading = false;
                    this.isExcludeLTEClicked = false;
                    this.getExcludeLTE();
                });
            }
        }
    }

    public cancelEditClick(evt: any, sched: OrderEventSchedule) {
        this.resetSchedule(sched);
    }

    public cancelMMClick(evt: any, sched: OrderEventSchedule) {
        this.isEditing = true;
        this.isCheckCall = false;
        this.isOrderEventSave = false;
        this.isButtonClicked = true;
        sched.cancelled = true;
        sched.completed = true;
    }

    public orderEventScheduleClick(evt: any, sched: OrderEventSchedule, isComplete: boolean, delayType: number) {
        //console.log(evt);
        this.isButtonClicked = true;
        this.isEditing = true;

        // 0 = Yes, 1 = No, 2 = No Answer
        this.delayTrackingEventType = delayType;

        if (sched.isNonStopOrderEvent && sched.code != "PPC") {
            this.isCheckCall = false;
        }
        else {
            this.isCheckCall = !isComplete;
            this.isOrderEventSave = isComplete;
            this.trackingCheckCall = this.getNewCheckCall(sched.code, sched.orderEventTypeID);
            if (sched.code == "PPC") {
                //this.defaultCheckCallCity = this.orderEventScheduleView.find(c => c.orderEventScheduleID == sched.orderEventScheduleID)!.stopCityState;
                //this.setDefaultCheckCallCity(sched);
                if (sched.cityID != this.checkCallCity.cityID) {
                    this.checkCallCitySet(sched.cityID, sched);
                }
            }
        }
        this.setNextETADate(sched);
        sched.completed = isComplete;

        this.checkLateOrEscalate(sched);
    }

    private checkLateOrEscalate(sched: OrderEventSchedule) {
        this.isLateForArv = false;
        this.isRequireLateReason = false;
        var thisStop = this.orderStops.find(t => t.orderStopId == sched.orderStopID);
        var code = this.getEventCode(sched.orderEventTypeID);
        var isArv: boolean = code.includes("-Arv");

        if (thisStop != null) {
            //var schedDate = (sched.nextETADate != null ? sched.nextETADate : sched.orderEventDate);
            var schedDate = sched.orderEventDate;
            // When arrival > planned.latest use arrival time otherwise planned latest
            var compareDate = (thisStop!.arrivalDate > thisStop!.latestDate ? thisStop!.arrivalDate : thisStop!.latestDate);
            var compareLateReasonDate = thisStop!.latestDate;
            if (isArv) {
                if (schedDate > compareLateReasonDate) {
                    this.isRequireLateReason = true;
                }
                if (schedDate > compareDate) {
                    this.isLateForArv = true;
                }
                if (this.trackingCheckCall.lateInd == true) {
                    this.isLateForArv = true;
                }
            }
        }

        //console.log("checkLateOrEscalate", isArv, this.isLateForArv, schedDate, compareDate, sched);
    }

    public isShowLateReason(sched: OrderEventSchedule) {
        this.checkLateOrEscalate(sched);
        var isShow: boolean = false;
        if (this.isRequireLateReason && sched.completed) {
            isShow = true;
        }
        return isShow;
    }

    public isSaveDisable(sched: OrderEventSchedule) {
        var isDisable: boolean = false;
        var code = this.getEventCode(sched.orderEventTypeID);
        if (sched.completed == true
            && (code == 'MM' || code == 'CLR')
            && this.isCheckCall
            && (!this.isNonStopDateValid || !this.isCheckCallCitySet || this.trackingCheckCall!.comment.trim() == '')
        ) {
            isDisable = true;
        }
        else if (sched.completed == true && this.isRequireLateReason && sched.orderStop.stopLateReasonID == null) {
            isDisable = true;
        }
        return isDisable;
    }

    public canShowCheckCall(sched: OrderEventSchedule) {
        var isShow: boolean = false;
        var code = this.getEventCode(sched.orderEventTypeID);
        if (this.orderEventSchedule[0].orderEventScheduleID == sched.orderEventScheduleID
            && this.isButtonClicked
            && (this.isCheckCall
                || code == 'PPC' && sched.completed != true && this.isCheckCall
                || code == 'LTE')
        ) {
            isShow = true;
        }
        return isShow;
    }

    public canShowButton(sched: OrderEventSchedule, btnType) {
        var isShow: boolean = false;
        var isStop = (sched.orderStopID > 0);
        var isComplete: boolean = false;
        var isLate: boolean = false;
        var isYes: boolean = (this.delayTrackingEventType == 0);
        var isNo: boolean = (this.delayTrackingEventType == 1);
        var isNoAnswer: boolean = (this.delayTrackingEventType == 2);
        var isSaveAndEscalateOnly: boolean = false;
        var isCityRequired: boolean = false;

        this.checkLateOrEscalate(sched);

        if (sched.completed == true) {
            isComplete = true;
        }

        var isLTESave: boolean = (sched.code == "LTE" && this.isNonStopEventSave && this.delayMinutes == 0);

        if (isLTESave && !this.isCheckCallCitySet) {
            isCityRequired = true;
        }

        isLTESave = false;

        if (this.isLateForArv == true || this.trackingCheckCall!.lateInd == true) {
            isLate = true;
        }

        //isSaveAndEscalateOnly = (isNo && isLate);
        isSaveAndEscalateOnly = (isLate && !(isStop && isYes) || isLTESave);

        if (btnType == "cancelEditButton") {
            isShow = true;
        }
        else if (isCityRequired && !this.isCheckCallCitySet) {
            isShow = false;
        }
        else if (btnType == "sendEscalationEmailButton") {
            if (isNo || isNoAnswer || isLate || isLTESave) {
                isShow = true;
            }
        }
        else if (!isSaveAndEscalateOnly) {
            if (btnType == "saveAndEmailButton") {
                isShow = true;
            }
            else if (btnType == "saveCancelNonStop") {
                if (sched.cancelled) {
                    isShow = true;
                }
            }
            else if (btnType == "saveOrderEventButton") {
                if (this.isOrderEventSave) {
                    isShow = true;
                }
            }
            else if (btnType == "saveNonStopEventButton") {
                if (this.isNonStopEventSave) {
                    isShow = true;
                }
            }
            else if (btnType == "saveCheckCallButton") {
                if (this.isCheckCall && !sched.cancelled && !this.isNonStopEventSave) {
                    isShow = true;
                }
            }
        }

        //console.log("isShowSaveButton", isShow, btnType, isShowEscalateOnly, isLateForArv)

        return isShow;
    }

    public saveOrderEventClick(evt: any, sched: OrderEventSchedule) {
        this.recordLockHandleEvent = evt;
        this.recordLockHandleSchedule = sched;
        this.recordLockAction = "saveOrderEventClick";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    private allowSaveOrderEventClick(evt: any, sched: OrderEventSchedule, isEmail: boolean) {
        this.recordLockHandleEvent = undefined;
        this.recordLockHandleSchedule = {} as OrderEventSchedule;
        if (this.currentOrderEventSchedule) {
            var isLateMM = sched.code == "MM" && (this.trackingCheckCall ? this.trackingCheckCall.lateInd : false);
            if (isLateMM) {
                var hdr = "Stop Late Arrival Warning";
                var msg = this.getLateMMWarning();

                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = false;
                dialogConfig.autoFocus = true;
                dialogConfig.data = {
                    header: hdr,
                    message: msg,
                    yesText: "Acknowledge",
                    noText: "Cancel"
                }

                const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

                dialogRef.afterClosed().subscribe(dialogResult => {
                    if (!dialogResult) {
                        //this.saveOrderEventValidationOK(sched, false);
                        this.cancelEditClick({}, sched);
                    }
                    else {
                        this.saveOrderEventValidationOK(sched, true, isEmail);
                    }
                });
            }
            else {
                var diffMins = this.utilService.getDateDiffMin(this.currentOrderEventSchedule.orderEventDate, sched.orderEventDate);
                if (diffMins > 60) {
                    const dialogConfig = new MatDialogConfig();
                    dialogConfig.disableClose = false;
                    dialogConfig.autoFocus = true;
                    dialogConfig.data = {
                        header: 'Event Time Warning',
                        message: 'The new time entered is more than 60 minutes from the original time. Continue?'
                    }

                    const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

                    dialogRef.afterClosed().subscribe(dialogResult => {
                        if (!dialogResult) return;

                        var code = this.getEventCode(sched.orderEventTypeID);
                        if (code == "PPC") {
                            this.saveOrderEventValidationOK(sched, true, isEmail);
                        }
                        else {
                            this.saveOrderEventValidationOK(sched, false, isEmail);
                        }
                    });
                }
                else {
                    this.saveOrderEventValidationOK(sched, false, isEmail);
                }
            }
        }
    }

    private saveOrderEventValidationOK(scheduleItem: OrderEventSchedule, isUpdateFuture: boolean, isEmail: boolean) {
        console.log("saveOrderEventValidationOK", scheduleItem, isUpdateFuture);
        var sched: OrderEventSchedule = Object.assign({}, scheduleItem);
        var editedSched: OrderEventSchedule = Object.assign({}, scheduleItem);
        editedSched.orderEventDate = this.utilService.getDateAsUTC(editedSched.orderEventDate);
        if (editedSched.nextETADate != null) {
            editedSched.nextETADate = this.utilService.getDateAsUTC(editedSched.nextETADate);
        }
        if (editedSched.completedDate != null) {
            editedSched.completedDate = this.utilService.getDateAsUTC(editedSched.completedDate);
        }
        if (editedSched.completed == true) {
            editedSched.completedDate = new Date();
            editedSched.completedByEmployeeID = this.utilService.getEmployeeID();
            sched.completedDate = new Date();
            sched.completedByEmployeeID = this.utilService.getEmployeeID();
            this.utilService.setAuditNotes("Tracking: Complete Event");
            this.isLoading = true;
            this.orderService.saveOrderEventSchedule(editedSched, isUpdateFuture).subscribe(result => {
                this.isLoading = false;
                if (result.message.indexOf("already completed") > 0 || result.errorCollection.length > 0) {
                    this.isErrorSavingData = true;
                    this.errorSavingDataMessage = this.getErrorCollectionMessage(result);
                }
                else {
                    if (result.message != "OK") {
                        this.notificationService.showError("Error saving event: " + result.message, "ERROR: Event Save");
                    }
                    else {
                        this.saveReferenceNumber(sched);
                        if (sched.cancelled == true) {
                            this.addCancelledEventCheckCall(sched);
                        }
                        else {
                            sched.orderEventDateUTC = editedSched.orderEventDate;
                            this.addCompletedStopEventCheckCall(sched, isEmail);
                        }
                    }
                    this.refreshViews(sched);
                }
            });
        }
        else {
            this.utilService.setAuditNotes("Tracking: Save Event");
            this.isLoading = true;
            this.orderService.saveOrderEventSchedule(editedSched, isUpdateFuture).subscribe(result => {
                this.isLoading = false;
                if (result.message.indexOf("already completed") > 0 || result.errorCollection.length > 0) {
                    this.isErrorSavingData = true;
                    this.errorSavingDataMessage = this.getErrorCollectionMessage(result);
                }
                else {
                    if (result.message != "OK") {
                        this.notificationService.showError("Error saving event: " + result.message, "ERROR: Event Save");
                    }
                    else {
                        this.saveReferenceNumber(sched);
                        this.saveNonStopEventCheckCall(sched, isEmail);
                    }
                    this.refreshViews(sched);
                }
            });
        }
        this.isEditing = false;
    }

    private getLateMMWarning() {
        var est = this.trackingCheckCall!.estimatedDeliveryDate;
        var eta = (est.getMonth() + 1) + '/' + est.getDate() + '/' + est.getFullYear() + ' ' + est.getHours() + ':' +
            (est.getMinutes() < 10 ? '0' + est.getMinutes() : est.getMinutes());

        //var msg = "The new time entered will make the Arrival ETA late. Auto-adjust remaining events and stops for the day?";
        //var msg = "Based on the driver's current location they will be late. ETA is now " + eta + ". ";
        //msg += "Please validate directly with driver and confirm ETA. ";
        //msg += "Auto-adjust remaining events and stops for the day?";
        var msg = "Based on the driver's current location they will be late. Their ETA is now " + eta + ". ";
        msg += "By Clicking 'Acknowledge' you are agreeing that you have ensured this update is being escalated to AM team.";
        return msg;
    }

    private addCancelledEventCheckCall(sched: OrderEventSchedule) {
        this.trackingCheckCall = this.getNewCheckCall("", sched.orderEventTypeID);
        this.trackingCheckCall.orderEventScheduleID = sched.orderEventScheduleID;
        this.trackingCheckCall.checkCallAction = "Cancel";
        var modifiedByName = localStorage.getItem('EmployeeFullName')!;
        this.trackingCheckCall.comment = "MM: Manually cancelled by " + modifiedByName;
        if (sched.notes != "") {
            this.trackingCheckCall.checkCallNote = sched.notes;
            this.trackingCheckCall.comment += "; " + sched.notes;
        }
        this.saveCheckCall(this.trackingCheckCall, true, false);
    }

    private addCompletedStopEventCheckCall(sched: OrderEventSchedule, isEmail: boolean) {
        var code = this.getEventCode(sched.orderEventTypeID);
        if (sched.orderStop || code == "PPC") {
            this.trackingCheckCall = this.getNewCheckCall(code, sched.orderEventTypeID);
            this.trackingCheckCall.checkCallAction = "Completed";

            if (sched.completed != true && sched.orderStop) {
                this.trackingCheckCall.eventCode = "CHK";
            }
            this.trackingCheckCall.orderEventScheduleID = sched.orderEventScheduleID;
            this.trackingCheckCall.updatedOrderEventDateUTC = sched.orderEventDate; //sched.orderEventDateUTC;
            this.trackingCheckCall.cityId = sched.cityID;
            var eventDate = formatDate(sched.completedDate, "MMM d yyyy h:mmaaa", "en-US");
            //var isSaveCheckCall = true;
            var eventType = this.trackingEventTypes.find(t => t.code == sched.code);
            var eventText = sched.code.toUpperCase();
            var reportDesc = "";
            var verifiedText = "";

            if (eventType) {
                if (eventType.reportDescription != null) {
                    reportDesc = eventType.reportDescription + ", ";
                }
                if (sched.code.indexOf("-Arv") > 0) {
                    verifiedText = "Arrival ";
                }
                else if (sched.code.indexOf("-Dep") > 0) {
                    verifiedText = "Departure ";
                }
            }

            verifiedText += "Verified @ " + eventDate;

            this.trackingCheckCall.comment = eventText + ": " + reportDesc + verifiedText;

            if (sched.orderStop != null && sched.orderStop.stopLateReasonID > 0) {
                var lateReason = this.stopLateReasonList.find(t => t.stopLateReasonID == sched.orderStop.stopLateReasonID);
                if (lateReason != null) {
                    this.trackingCheckCall.stopLateReasonID = lateReason.stopLateReasonID;
                    this.trackingCheckCall.comment += ". LATE REASON: " + lateReason.stopLateReasonDescription;
                    this.trackingCheckCall.lateInd = true;
                }
            }
            this.isRequireLateReason = false;

            this.saveCheckCall(this.trackingCheckCall, true, isEmail);
        }
    }

    public saveAndSendEscalationEmailClick(evt: any, sched: OrderEventSchedule) {
        this.isEscalation = true;
        this.saveAndEmailClick(evt, sched);
    }

    public saveCheckCallClick(evt: any, sched: OrderEventSchedule) {
        var isLateMM = sched.code == "MM" && (this.trackingCheckCall ? this.trackingCheckCall.lateInd : false);
        if (isLateMM) {
            var hdr = "Stop Late Arrival Warning";
            var msg = this.getLateMMWarning();

            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = false;
            dialogConfig.autoFocus = true;
            //dialogConfig.width = '400px',
            dialogConfig.data = {
                header: hdr,
                message: msg,
                yesText: "Acknowledge",
                noText: "Cancel"
            }

            const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

            dialogRef.afterClosed().subscribe(dialogResult => {
                if (!dialogResult) {
                    //this.saveCheckCallValidationOK(sched, false, false);
                    this.cancelEditClick({}, sched);
                }
                else {
                    this.saveCheckCallValidationOK(sched, false, true);
                }
            });
        }
        else {
            var diffMins = this.utilService.getDateDiffMin(this.currentOrderEventSchedule!.orderEventDate, sched.orderEventDate);
            if (diffMins > 60) {
                var hdr = "Event Time Warning";
                var msg = "The new time entered is more than 60 minutes from the original time. Continue?";

                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = false;
                dialogConfig.autoFocus = true;
                //dialogConfig.width = '400px',
                dialogConfig.data = {
                    header: hdr,
                    message: msg
                }

                const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

                dialogRef.afterClosed().subscribe(dialogResult => {
                    if (!dialogResult) return;

                    var code = this.getEventCode(sched.orderEventTypeID);
                    if (code == "PPC") {
                        this.saveCheckCallValidationOK(sched, false, true);
                    }
                    else {
                        this.saveCheckCallValidationOK(sched, false, false);
                    }
                });
            }
            else {
                this.saveCheckCallValidationOK(sched, false, false);
            }
        }
    }

    public saveAndEmailClick(evt: any, sched: OrderEventSchedule) {
        this.recordLockHandleEvent = evt;
        this.recordLockHandleSchedule = sched;
        this.recordLockAction = "saveAndEmailClick";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
        console.log("saveAndEmailClick", evt, sched, this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    private allowSaveAndEmailClick(evt: any, sched: OrderEventSchedule) {
        this.recordLockHandleEvent = undefined;
        this.recordLockHandleSchedule = {} as OrderEventSchedule;
        var isLateMM = sched.code == "MM" && (this.trackingCheckCall ? this.trackingCheckCall.lateInd : false);
        if (isLateMM) {
            var hdr = "Stop Late Arrival Warning";
            var msg = this.getLateMMWarning();

            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = false;
            dialogConfig.autoFocus = true;
            //dialogConfig.width = '400px',
            dialogConfig.data = {
                header: hdr,
                message: msg,
                yesText: "Acknowledge",
                noText: "Cancel"
            }

            const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

            dialogRef.afterClosed().subscribe(dialogResult => {
                if (!dialogResult) {
                    //if (this.isNonStopEventSave) {
                    //    this.saveNonStopEventValidationOK(sched, true, false);
                    //}
                    //else if (this.isCheckCall) {
                    //    this.saveCheckCallValidationOK(sched, true, false);
                    //}
                    this.cancelEditClick({}, sched);
                }
                else {
                    if (this.isNonStopEventSave) {
                        this.saveNonStopEventValidationOK(sched, true, true);
                    }
                    else if (this.isCheckCall) {
                        this.saveCheckCallValidationOK(sched, true, true);
                    }
                }
            });
        }
        else {
            var diffMins = this.utilService.getDateDiffMin(this.currentOrderEventSchedule!.orderEventDate, sched.orderEventDate);
            console.log("allowSaveAndEmailClick:dialogRef", this.isNonStopEventSave, this.isCheckCall, diffMins);
            if (sched.code == "MM" || diffMins > 60) {
                var hdr = "Event Time Warning";
                var msg = "The new time entered is more than 60 minutes from the original time. Continue?";

                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = false;
                dialogConfig.autoFocus = true;
                dialogConfig.data = {
                    header: hdr,
                    message: msg
                }

                const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

                dialogRef.afterClosed().subscribe(dialogResult => {
                    if (!dialogResult) return;

                    if (this.isNonStopEventSave) {
                        this.saveNonStopEventValidationOK(sched, true, false);
                    }
                    else if (this.isCheckCall) {
                        this.saveCheckCallValidationOK(sched, true, false);
                    }
                    else {
                        this.allowSaveOrderEventClick(evt, sched, true);
                    }
                });
            }
            else {
                if (this.isNonStopEventSave) {
                    this.saveNonStopEventValidationOK(sched, true, false);
                }
                else if (this.isCheckCall) {
                    this.saveCheckCallValidationOK(sched, true, false);
                }
                else {
                    this.allowSaveOrderEventClick(evt, sched, true);
                }
            }
        }
    }

    private saveCheckCallValidationOK(scheduleItem: OrderEventSchedule, isEmail: boolean, isUpdateFuture: boolean) {
        var sched: OrderEventSchedule = Object.assign({}, scheduleItem);
        var editedSched: OrderEventSchedule = Object.assign({}, scheduleItem);
        console.log("saveCheckCallValidationOK", sched, isUpdateFuture);

        if (this.isCheckCall) {
            this.isOrderEventSave = true;
            this.isLoading = true;

            this.setCheckCallFields(scheduleItem);

            editedSched.orderEventDate = this.utilService.getDateAsUTC(editedSched.orderEventDate);
            if (editedSched.nextETADate != null) {
                editedSched.nextETADate = this.utilService.getDateAsUTC(editedSched.nextETADate);
            }
            if (editedSched.completedDate != null) {
                editedSched.completedDate = this.utilService.getDateAsUTC(editedSched.completedDate);
            }

            this.utilService.setAuditNotes("Tracking: Save Event");
            this.orderService.saveOrderEventSchedule(editedSched, isUpdateFuture).subscribe(result => {
                this.isLoading = false;
                if (result.message.indexOf("already completed") > 0 || result.errorCollection.length > 0) {
                    this.isErrorSavingData = true;
                    this.errorSavingDataMessage = this.getErrorCollectionMessage(result);
                }
                else {
                    if (result.message != "OK") {
                        this.notificationService.showError("Error saving event: " + result.message, "ERROR: Event Save");
                        this.refreshViews(sched);
                    }
                    else {
                        this.saveCheckCall(this.trackingCheckCall!, true, isEmail);
                        this.saveReferenceNumber(sched);

                        if (isEmail) {
                            //this.sendCheckCallEmail(this.trackingCheckCall!);
                        }
                        else {
                            this.isEscalation = false;
                            this.refreshViews(sched);
                        }
                    }
                }
            });
        }
        this.isEditing = false;
    }

    private saveNonStopEventValidationOK(scheduleItem: OrderEventSchedule, isEmail: boolean, isUpdateFuture: boolean) {
        var sched: OrderEventSchedule = Object.assign({}, scheduleItem);
        var editedSched: OrderEventSchedule = Object.assign({}, scheduleItem);
        console.log("saveNonStopEventValidationOK", scheduleItem, isUpdateFuture);

        //var notes = this.trackingCheckCall!.checkCallNote;
        var notes = this.trackingCheckCall!.comment;
        var isError = false;

        // Set city selected for Arrived (completed)
        if (sched.completed == true) {
            //var city = this.checkCallForm.controls['checkCallCityControl'].value as City;
            var city = this.checkCallCity;
            sched.cityID = city.cityID;
            editedSched.cityID = city.cityID;
            this.currentOrderEventSchedule.cityID = city.cityID;
            this.editedOrderEventSchedule.cityID = city.cityID;
        }

        editedSched.orderEventDate = this.utilService.getDateAsUTC(editedSched.orderEventDate);
        if (editedSched.nextETADate != null) {
            editedSched.nextETADate = this.utilService.getDateAsUTC(editedSched.nextETADate);
        }
        if (editedSched.completedDate != null) {
            editedSched.completedDate = this.utilService.getDateAsUTC(editedSched.completedDate);
        }

        if (this.delayMinutes > 0) {
            this.orderService.delayMileMarkersOrderEventSchedule(sched.quoteOrderLineID, sched.orderEventSequence, this.delayMinutes).subscribe(result => {
                var ok2 = result;
                this.utilService.setAuditNotes("Tracking: Save Delay Non-Stop Event");
                this.orderService.saveOrderEventSchedule(editedSched, isUpdateFuture).subscribe(result => {
                    this.isLoading = false;
                    if (result.message.indexOf("already completed") > 0 || result.errorCollection.length > 0) {
                        isError = true;
                        this.isErrorSavingData = true;
                        this.errorSavingDataMessage = this.getErrorCollectionMessage(result);
                    }
                    else {
                        if (result.message != "OK") {
                            isError = true;
                            this.notificationService.showError("Error saving event: " + result.message, "ERROR: Non-Stop Event Save");
                        }

                        if (this.isCheckCall && !isError) {
                            console.log("saveNonStopEventValidationOK DONE", sched);
                            this.saveNonStopEventCheckCall(sched, isEmail);
                        }

                        this.refreshViews(sched);
                    }
                });
            });
        }
        else {
            this.utilService.setAuditNotes("Tracking: Save Event");
            this.orderService.saveOrderEventSchedule(editedSched, isUpdateFuture).subscribe(result => {
                this.isLoading = false;
                if (result.message.indexOf("already completed") > 0 || result.errorCollection.length > 0) {
                    isError = true;
                    this.isErrorSavingData = true;
                    this.errorSavingDataMessage = this.getErrorCollectionMessage(result);
                }
                else {
                    if (result.message != "OK") {
                        isError = true;
                        this.notificationService.showError("Error saving event: " + result.message, "ERROR: Non-Stop Event Save");
                    }
                    else if (sched.completed == true && sched.code == "CLR") {
                        //console.log("sendTrackingEmail", notes);
                        this.sendTrackingEmail(sched, this.searchLine!.quoteOrderID, this.searchLine!.orderNumber, notes);
                    }

                    if (this.isCheckCall && !isError) {
                        console.log("saveNonStopEventValidationOK DONE", sched);
                        this.saveNonStopEventCheckCall(sched, isEmail);
                    }

                    this.refreshViews(sched);
                }
            });
        }
    }

    private saveNonStopEventCheckCall(scheduleItem: OrderEventSchedule, isEmail: boolean) {
        var sched: OrderEventSchedule = Object.assign({}, scheduleItem);
        //console.log("saveNonStopEventCheckCall", sched);

        this.setCheckCallFields(sched);

        this.saveCheckCall(this.trackingCheckCall, true, isEmail);
        if (isEmail) {
            //this.sendCheckCallEmail(this.trackingCheckCall!);
            this.isEditing = false;
        }
        else {
            this.isEscalation = false;
        }
    }

    selectedEmail() {
        return localStorage.getItem('EpiEmail');
    }

    public viewTrackingInfo(dataItem: TrackingBoard) {
        this.recordLockAction = "";
        //if (this.selectedTrackingBoard.quoteOrderID) {
        //    this.recordLockService.clearRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
        //    //this.recordLockService.clearRecordLock(this.recordLockService.recordLock.recordLockID);
        //}

        this.isSelectedRowLoading = true;
        //console.log(dataItem);
        this.initFields();
        var board = { ...dataItem };
        this.quoteOrderLineID = board.quoteOrderLineId;
        this.quoteOrderID = board.quoteOrderID;
        board.trackingBoardDetail = [];
        this.recordLockAction = "viewTrackingInfo";
        if (this.selectedTrackingBoard.quoteOrderID) {
            this.recordLockService.clearRecordLockObservable("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource).subscribe(result => {
                this.handleRecordLock(board.quoteOrderID);
            });
        }
        else {
            this.handleRecordLock(board.quoteOrderID);
        }
        this.setCurrentTrackingBoard(board);
        //this.getMacropointUrl(board);
        //console.log(this.trackingBoardSingle);
        this.getOrderEventScheduleView();
        this.getSearchQuoteOrderLine(dataItem.quoteOrderID, dataItem.quoteOrderLineId);
        //this.getCheckCalls(board.quoteOrderLineId);
        this.getReferenceNumbers(board.quoteOrderID);
    }

    public closeTrackingInfo(dataItem: TrackingBoard) {
        this.recordLockAction = "";
        this.recordLockService.clearRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
        this.recordLockService.resetRecordLock();
        //this.recordLockService.clearRecordLock(this.recordLockService.recordLock.recordLockID);
        var emptyBoard: TrackingBoard = {} as TrackingBoard;
        this.quoteOrder = {} as QuoteOrder;
        this.quoteOrderLineID = 0;
        this.quoteOrderID = 0;
        this.selectedTrackingBoard = emptyBoard;
    }

    private setCurrentTrackingBoard(board: TrackingBoard) {
        this.quoteOrder = {} as QuoteOrder;
        this.selectedTrackingBoard = board;
        this.trackingBoardSingle.length = 0;
        this.trackingBoardSingle.push(board);
    }

    public trackingRowCallback(context: RowClassArgs) {
        const isHighPriority = (context.dataItem.loadPriorityAbbreviation == "High" || context.dataItem.nextEvent == "LTE");
        const isExpedite = (context.dataItem.rateIndex == "Expedite");
        if (isExpedite) {
            return {
                expedite: isExpedite
            }
        }
        else if (isHighPriority) {
            return {
                highPriority: isHighPriority
            }
        }
    }

    public trackingBoardRowSelected(e: any) {
        //console.log("trackingBoardRowSelected", e.selectedRows);
        if (!this.isSelectedRowLoading) {
            this.viewTrackingInfo(e.selectedRows[0].dataItem);
        }
    }

    private resetSchedule(sched: OrderEventSchedule) {
        this.initFields();

        this.getStops(false);
        this.getOrderEventScheduleView();
    }

    public refreshTrackingBoard() {
        this.quoteOrder = {} as QuoteOrder;
        this.selectedTrackingBoard = {} as TrackingBoard;
        this.initFields();
        this.getTrackingBoard({} as TrackingBoard);
    }

    public refreshAfterStopsUpdate() {
        this.initFields();
        this.getStops(false);
        this.getOrderEventScheduleView();
        this.getTrackingBoard(this.selectedTrackingBoard);
        this.stopsRefreshDate = new Date();
        this.checkCallRefreshDate = new Date();
        //console.log("refreshAfterStopsUpdate", this.quoteOrderLineID, this.currentOrderEventSchedule);
    }

    private refreshViews(sched: OrderEventSchedule) {
        //console.log("refreshViews", sched, this.isRemainOpenAfterSave);
        this.stopsRefreshDate = new Date();
        if (sched.quoteOrderLineID > 0) {
            this.orderService.exportQuoteOrder(sched.quoteOrderLineID).subscribe(exportedOrder => {
                console.log("exportQuoteOrder:result", exportedOrder);
            });
        }
        if (this.isRemainOpenAfterSave) {
            this.initFields();
            this.getStops(false);
            this.getOrderEventScheduleView();
        }
        else {
            this.getStops(true);
            this.closeTrackingInfo(this.selectedTrackingBoard);
            this.initFields();
        }
        this.getTrackingBoard(this.selectedTrackingBoard);
    }

    //private updateERPByQuoteOrderLineID(id: number) {
    //    this.applicationControlService.getApplicationControlsByAppName("ExportHub").subscribe(result => {
    //        if (result.length > 0) {
    //            var appValue = result[0].appSettingValue;
    //            if (appValue == "1") {
    //                this.isExportHub = true;
    //            }
    //            else {
    //                this.isExportHub = false;
    //            }
    //        }
    //        if (this.isExportHub != true) {
    //            this.notificationService.showInfo("Updating TMW Stops ...", "TMW Update");
    //            this.orderService.updateERPOrderStopsByQuoteOrderLineId(id, "TMW").subscribe(result => {
    //                var ok = result;
    //                if (result.message != "OK") {
    //                    this.notificationService.showError("Error updating TMW: " + result.message, "ERROR: TMW Update");
    //                }
    //                else {
    //                    this.notificationService.showInfo("TMW Update Complete", "TMW Update");
    //                }
    //            });
    //        }
    //    });
    //}

    public checkAllTrackingComplete() {
        var view = this.orderEventScheduleView.filter(s => s.completed == false);
        if (view.length == 0) {
            this.isAllTrackingComplete = true;
        }
        else {
            this.isAllTrackingComplete = false;
        }
    }

    public trackingBoardStateChange(state: DataStateChangeEvent) {
        this.trackingBoardState = state;
        this.trackingBoardState.filter = state.filter;
        //console.log("trackingBoardStateChange", state.filter);
        this.setTrackingBoardGrid();
    }

    private isValidOrderEventDate(sched: OrderEventSchedule) {
        var minDate = this.getMinDateByEventStop(sched);
        var maxDate = this.getMaxDateByEventStop(sched);
        var schedDate = this.getLocalTime(sched.orderEventDate);
        //console.log("isValidOrderEventDate", sched.orderEventDate, schedDate, minDate, maxDate);
        var isValid = true;
        if (minDate != undefined) {
            if (schedDate <= new Date(minDate)) {
                //console.log("isValidOrderEventDate:minDate", sched.orderEventDate, schedDate, minDate);
                isValid = false;
            }
        }
        if (maxDate != undefined) {
            if (schedDate >= new Date(maxDate)) {
                //console.log("isValidOrderEventDate:maxDate", sched.orderEventDate, schedDate, maxDate);
                isValid = false;
            }
        }
        return isValid;
    }

    private setNextETADate(sched: OrderEventSchedule) {
        var timeOffset: Date = new Date();
        var currDate: Date = new Date();
        if (this.delayTrackingEventType == 2) {
            // No Answer : add delay minutes to Now
            timeOffset = new Date(new Date().getTime() + this.delayTrackingEventETAMinutes * 60000);
            if (sched.epiTimeZone) {
                timeOffset = this.utilService.getLocalDateInTimeZone(timeOffset, sched.epiTimeZone.ianaTimeZoneName);
                //console.log("setNextETADate:No Answer", timeOffset, sched.epiTimeZone);
            }
            sched.nextETADate = timeOffset;
        }
        else if (sched.code.indexOf("-Arv") > 0 || sched.code.indexOf("-Dep") > 0 || sched.code == "PPC") {
            // Only allow ETA delay for Arrivals
            currDate = new Date(sched.orderEventDate);
            if (this.delayTrackingEventType == 1) {
                // No : add delay minutes to current ETA
                timeOffset = new Date(currDate.getTime() + this.delayTrackingEventETAMinutes * 60000);
                sched.nextETADate = timeOffset;
            }
            //else if (this.delayTrackingEventType == 2) {
            //    // No Answer : add delay minutes to Now
            //    timeOffset = new Date(new Date().getTime() + this.delayTrackingEventETAMinutes * 60000);
            //    sched.nextETADate = timeOffset;
            //}
            else {
                // Yes (default) : no ETA for arrival complete
                //sched.nextETADate = currDate;
                sched.nextETADate = undefined;
            }
        }
        if (sched.nextETADate != undefined) {
            this.trackingCheckCall.nextETADateUTC = sched.nextETADate; // this.utilService.getDateAsUTC(sched.nextETADate);
        }
        //console.log("setNextETADate", timeOffset.toLocaleString(), currDate.toLocaleString(), this.delayTrackingEventETAMinutes, sched.nextETADate!.toLocaleString(), sched.orderEventDate.toLocaleString());
    }

    public orderEventDateChanged(sched: OrderEventSchedule, isNextStop: boolean) {
        if (sched.code.indexOf("BMT") == 0) {
            // Set BMT-Arv date to BMT-Dep date to avoid invalid dates
            sched.orderStop.arrivalDate = sched.orderStop.departDate;
        }
        //console.log("orderEventDateChanged", this.isValidOrderEventDate(sched), sched);
        //if (isNextStop) {
        //    this.isNextStopValid = this.isValidOrderEventDate(sched);
        //}
        //else {
        this.isStopValid = (sched.code == "PPC" || this.isValidOrderEventDate(sched));
        //}
        if (this.isStopValid) {
            if (sched.code.indexOf("-Arv") > 0) {
                sched.orderStop.arrivalDate = sched.orderEventDate;
                //this.arrivalDateChanged(sched.orderStop);
            }
            if (sched.code.indexOf("-Dep") > 0) {
                sched.orderStop.departDate = sched.orderEventDate;
                //this.departDateChanged(sched.orderStop);
            }
        }

        this.setNextETADate(sched);
        this.setCheckCallFields(sched);
        this.checkLateOrEscalate(sched);
    }

    public nonStopEventDateChanged(sched: OrderEventSchedule) {
        this.isEditing = true;
        this.isNonStopEventSave = true;
        this.isCheckCall = true;
        this.isNonStopDateValid = (new Date() < sched.orderEventDate ? false : true);
        if (sched.code == "PPC") {
            //this.setDefaultCheckCallCity(sched);
            //this.defaultCheckCallCity = this.orderEventScheduleView.find(c => c.orderEventScheduleID == sched.orderEventScheduleID)!.stopCityState;
            if (sched.cityID != this.checkCallCity.cityID) {
                this.checkCallCitySet(sched.cityID, sched);
            }
        }
    }

    public getNowDate() {
        return new Date();
    }

    public delayNonStopEvent(sched: OrderEventSchedule, delayMinutes: number) {
        this.isButtonClicked = true;
        this.delayMinutes = delayMinutes;
        //this.checkCallForm.controls["checkCallCityControl"].setValue("");
        this.checkCallCity = {} as SearchCityState;
        this.checkCallCityID = 0;
        this.defaultCheckCallCity = "";

        if (this.isEditing != true) {
            // Increment the delay counter only on first delay until save is done
            sched.delayCount = (sched.delayCount == null ? 1 : sched.delayCount + 1);
        }
        this.isEditing = true;
        this.isNonStopEventSave = true;

        this.trackingCheckCall = this.getNewCheckCall(sched.code, sched.orderEventTypeID);
        if (delayMinutes != 0) {
            sched.completed = false;
            this.trackingCheckCall.checkCallAction = "Delay " + delayMinutes;
        }
        else {
            this.trackingCheckCall.checkCallAction = "Completed";
        }
        //if (delayMinutes == 0) {
        this.isCheckCall = true;
        //}
        //else {
        //    this.isCheckCall = false;
        //}

        if (sched.code == "PPC") {
            //this.setDefaultCheckCallCity(sched);
            //this.defaultCheckCallCity = this.orderEventScheduleView.find(c => c.orderEventScheduleID == sched.orderEventScheduleID)!.stopCityState;
            if (sched.cityID != this.checkCallCity.cityID) {
                this.checkCallCitySet(sched.cityID, sched);
            }
        }

        for (var i = 0; i < this.orderEventSchedule.length; i++) {
            if (this.orderEventSchedule[i].orderEventSequence == sched.orderEventSequence) {
                if (delayMinutes == 0 && sched.isNonStopOrderEvent) {
                    this.orderEventSchedule[i].completed = true;
                    this.orderEventSchedule[i].completedDate = new Date();
                    this.orderEventSchedule[i].completedByEmployeeID = this.utilService.getEmployeeID();
                }
                var scheduleTimeOffset = new Date(this.orderEventSchedule[i].orderEventDate.getTime() + delayMinutes * 60000);
                this.orderEventSchedule[i].orderEventDate = scheduleTimeOffset;
                sched.orderEventDate = scheduleTimeOffset;
                this.trackingCheckCall.updatedOrderEventDateUTC = sched.orderEventDate; //this.utilService.getDateAsUTC(sched.orderEventDate);
                //console.log("this.orderEventSchedule[i]", this.orderEventSchedule[i]);
            }
        }

        this.setCheckCallFields(sched);

        //var isNonStopEvent = true;
        //var i = 0;
        //for (var i = 0; i < this.orderEventSchedule.length; i++) {
        //    if (this.orderEventSchedule[i].orderEventSequence >= sched.orderEventSequence) {
        //        if (!this.orderEventSchedule[i].isNonStopOrderEvent) {
        //            isNonStopEvent = false;
        //        }
        //        // Only update current sequence of MM events
        //        if (this.orderEventSchedule[i].orderEventSequence == sched.orderEventSequence && delayMinutes == 0) {
        //            this.orderEventSchedule[i].completed = true;
        //            this.orderEventSchedule[i].completedDate = new Date();
        //            this.orderEventSchedule[i].completedByEmployeeId = this.utilService.getEmployeeID();
        //        }
        //        if (isNonStopEvent) {
        //            var scheduleTimeOffset = new Date(this.orderEventSchedule[i].orderEventDate.getTime() + delayMinutes * 60000);
        //            this.orderEventSchedule[i].orderEventDate = scheduleTimeOffset;
        //            //console.log("this.orderEventSchedule[i]", this.orderEventSchedule[i]);
        //        }
        //    }
        //}
    }

    public saveNonStopEventClick(evt: any, sched: OrderEventSchedule) {
        this.recordLockHandleEvent = evt;
        this.recordLockHandleSchedule = sched;
        this.recordLockAction = "saveNonStopEventClick";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    private allowSaveNonStopEventClick(evt: any, sched: OrderEventSchedule) {
        this.recordLockHandleEvent = undefined;
        this.recordLockHandleSchedule = {} as OrderEventSchedule;
        var isLateMM = sched.code == "MM" && (this.trackingCheckCall ? this.trackingCheckCall.lateInd : false);
        if (isLateMM) {
            var hdr = "Stop Late Arrival Warning";
            var msg = this.getLateMMWarning();

            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = false;
            dialogConfig.autoFocus = true;
            //dialogConfig.width = '400px',
            dialogConfig.data = {
                header: hdr,
                message: msg,
                yesText: "Acknowledge",
                noText: "Cancel"
            }

            const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

            dialogRef.afterClosed().subscribe(dialogResult => {
                if (!dialogResult) {
                    //this.saveNonStopEventValidationOK(sched, false, false);
                    this.cancelEditClick({}, sched);
                }
                else {
                    this.saveNonStopEventValidationOK(sched, false, true);
                }
            });
        }
        else {
            this.saveNonStopEventValidationOK(sched, false, false);
        }
    }

    public scheduleEventTypeChange(id: number) {
        this.scheduleViewSelectedEventType = this.addMultipleEventTypes.find(t => t.orderEventTypeID == id)!.code;
        if (this.scheduleViewSelectedEventType != "CLR") {
            if (this.addMultiple.instructions) {
                this.addMultiple.instructions = "";
                this.addMultiple.notificationEmails = "";
            }
            else if (this.editedOrderEventSchedule.instructions) {
                this.editedOrderEventSchedule.instructions = "";
                this.editedOrderEventSchedule.notificationEmails = "";
            }
        }
    }

    public addMultipleEventsClick() {
        this.isRemainOpenAfterSave = true;
        this.isAddMultipleEvents = true;
        this.isEditing = true;
    }

    public convertMMtoCLRClick() {
        this.isRemainOpenAfterSave = true;
        this.isConvertMMtoCLR = true;
        this.isEditing = true;
    }

    public deleteRemainingMMClick() {
        this.recordLockAction = "deleteRemainingMMClick";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    private allowDeleteRemainingMMClick() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete Remaining MM?',
            message: 'You are about to delete all remaining MM events. Continue?'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) {
                return;
            }

            this.isRemainOpenAfterSave = true;
            this.isLoading = true;
            this.orderService.deleteMileMarkersOrderEventSchedule(this.selectedTrackingBoard.quoteOrderLineId).subscribe(result => {
                this.isLoading = false;
                if (result.errorCollection.length > 0) {
                    this.isErrorSavingData = true;
                    this.errorSavingDataMessage = this.getErrorCollectionMessage(result);
                }
                else if (result.message != "OK") {
                    this.notificationService.showError("Error deleting remaining mile markers: " + result.message, "ERROR: Delete Remaining MM");
                    this.refreshViews(this.currentOrderEventSchedule!);
                }
                else {
                    this.refreshViews(this.currentOrderEventSchedule!);
                }
            });
        });
    }

    public cancelScheduleDialogClick(isRemainOpen: boolean) {
        this.isRemainOpenAfterSave = isRemainOpen;
        this.isScheduleViewEdit = false;
        this.isAddMultipleEvents = false;
        this.isConvertMMtoCLR = false;
        this.isEditing = false;
        this.editedOrderEventSchedule = {} as OrderEventSchedule;
        this.editedScheduleView = undefined;
    }

    public saveScheduleViewClick() {
        this.recordLockAction = "saveScheduleViewClick";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    private allowSaveScheduleViewClick() {
        this.isRemainOpenAfterSave = true;
        //console.log("saveScheduleViewClick", this.editedOrderEventSchedule);
        var eventType = this.orderEventTypes.find(t => t.orderEventTypeID == this.editedOrderEventSchedule.orderEventTypeID);

        var isPPCDateEdit: boolean = (this.editedOrderEventSchedule.code == "PPC" && this.editedOrderEventSchedule.completed == true);

        if (!isPPCDateEdit) {
            // Get last event with EpiTimeZoneID set to use for converting dates to that timezone
            var orderEventDate: Date = new Date(this.editedOrderEventSchedule.orderEventDate);
            var schedList: OrderEventSchedule[] = this.fullOrderEventSchedule.filter(t =>
                t.orderEventDateUTC! < orderEventDate
                && t.epiTimeZoneID != null
                && t.epiTimeZoneID > 0
            );
            console.log("saveScheduleViewClick1", this.fullOrderEventSchedule, schedList, orderEventDate);
            var lastTimeZoneEvent = schedList.find(t => t.orderEventSequence == Math.max(...schedList.map(t => t.orderEventSequence)));
            if (lastTimeZoneEvent == undefined) {
                lastTimeZoneEvent = this.editedOrderEventSchedule;
            }
            var lastTimeZone = lastTimeZoneEvent!.epiTimeZone.ianaTimeZoneName;
            this.editedOrderEventSchedule.orderEventDate = this.utilService.getLocalDateInTimeZone(this.editedOrderEventSchedule.orderEventDate, lastTimeZone);
            if (this.editedOrderEventSchedule.nextETADate != null) {
                this.editedOrderEventSchedule.nextETADate = this.utilService.getLocalDateInTimeZone(this.editedOrderEventSchedule.nextETADate, lastTimeZone);
            }
            console.log("saveScheduleViewClick2", lastTimeZone, lastTimeZoneEvent!.orderEventDate, this.editedOrderEventSchedule.orderEventDate);
        }

        if (isPPCDateEdit) {
            // Updating previously completed PPC date
            this.isLoading = true;
            var editedSched: OrderEventSchedule = Object.assign({}, this.editedOrderEventSchedule);
            editedSched.orderEventDate = this.utilService.getDateAsUTC(editedSched.orderEventDate);
            console.log("allowSaveScheduleViewClick4", editedSched);
            this.orderService.saveCompletedPPCDate(editedSched).subscribe(result => {
                this.isLoading = false;
                if (result.message != "OK") {
                    this.notificationService.showError("Error saving event: " + result.message, "ERROR: Event Save");
                }
                //console.log(result);
                this.refreshViews(this.currentOrderEventSchedule!);
            });
        }
        else if (this.editedOrderEventSchedule.orderEventScheduleID <= 0) {
            var sched: any = {
                orderEventScheduleId: -1,
                orderEventTypeID: this.editedOrderEventSchedule.orderEventTypeID,
                orderStopId: 0,
                cityId: -1,
                quoteOrderLineId: this.editedOrderEventSchedule.quoteOrderLineID,
                orderEventSequence: 0,
                orderEventDate: this.editedOrderEventSchedule.orderEventDate,
                //quoteOrderLine: this.quoteOrderLine,
                orderEventType: eventType,
                completed: false,
                isRefreshNeeded: false,
                cancelled: false,
                notes: this.editedOrderEventSchedule.notes,
                instructions: this.editedOrderEventSchedule.instructions,
                notificationEmails: this.editedOrderEventSchedule.notificationEmails,
                epiTimeZoneID: (lastTimeZoneEvent ? lastTimeZoneEvent.epiTimeZoneID : null)
            }
            this.isLoading = true;
            sched.orderEventDate = this.utilService.getDateAsUTC(sched.orderEventDate);
            if (sched.nextETADate != null) {
                sched.nextETADate = this.utilService.getDateAsUTC(sched.nextETADate);
            }
            if (sched.completedDate != null) {
                sched.completedDate = this.utilService.getDateAsUTC(sched.completedDate);
            }
            this.utilService.setAuditNotes("Tracking Schedule Grid: Save Event");
            console.log("allowSaveScheduleViewClick4", sched);
            this.orderService.saveOrderEventSchedule(sched as OrderEventSchedule, false).subscribe(result => {
                this.isLoading = false;
                if (result.message.indexOf("already completed") > 0 || result.errorCollection.length > 0) {
                    this.isErrorSavingData = true;
                    this.errorSavingDataMessage = this.getErrorCollectionMessage(result);
                }
                else if (result.message != "OK") {
                    this.notificationService.showError("Error saving event: " + result.message, "ERROR: Event Save");
                    this.refreshViews(this.currentOrderEventSchedule!);
                }
                else {
                    //console.log(result);
                    this.isLoading = true;
                    this.orderService.setOrderEventScheduleViewByQuoteOrderLineId(sched.quoteOrderLineId).subscribe(result2 => {
                        this.isLoading = false;
                        var ok = result2;
                        //console.log(result2);
                        if (result2.errorCollection.length > 0) {
                            this.isErrorSavingData = true;
                            this.errorSavingDataMessage = this.getErrorCollectionMessage(result2);
                        }
                        else if (result2.message != "OK") {
                            this.notificationService.showError("Error saving event: " + result2.message, "ERROR: Event Save");
                        }
                        this.refreshViews(this.currentOrderEventSchedule!);
                    });
                }
            });
        }
        else {
            this.editedOrderEventSchedule.orderEventType = eventType!;
            if (this.editedOrderEventSchedule.cancelled == true && this.editedOrderEventSchedule.completed != true) {
                this.editedOrderEventSchedule.completed = true;
                this.editedOrderEventSchedule.completedDate = new Date();
                this.editedOrderEventSchedule.completedByEmployeeID = this.utilService.getEmployeeID();
            }
            //console.log(editedSched);
            this.isLoading = true;
            var isUpdateFuture = false;
            if (eventType!.code == "PPC") {
                isUpdateFuture = true;
            }
            var editedSched: OrderEventSchedule = Object.assign({}, this.editedOrderEventSchedule);
            editedSched.orderEventDate = this.utilService.getDateAsUTC(editedSched.orderEventDate);
            if (editedSched.nextETADate != null) {
                editedSched.nextETADate = this.utilService.getDateAsUTC(editedSched.nextETADate);
            }
            if (editedSched.completedDate != null) {
                editedSched.completedDate = this.utilService.getDateAsUTC(editedSched.completedDate);
            }
            if (lastTimeZoneEvent) {
                editedSched.epiTimeZoneID = lastTimeZoneEvent.epiTimeZoneID;
            }
            if (!editedSched.cityID) {
                editedSched.cityID = -1;
            }
            this.utilService.setAuditNotes("Tracking Schedule Grid: Save Event");
            console.log("allowSaveScheduleViewClick5", editedSched);
            this.orderService.saveOrderEventSchedule(editedSched, isUpdateFuture).subscribe(result => {
                this.isLoading = false;
                if (result.message.indexOf("already completed") > 0 || result.errorCollection.length > 0) {
                    this.isErrorSavingData = true;
                    this.errorSavingDataMessage = this.getErrorCollectionMessage(result);
                }
                else {
                    if (result.message != "OK") {
                        this.notificationService.showError("Error saving event: " + result.message, "ERROR: Event Save");
                    }
                    if (this.editedOrderEventSchedule.cancelled == true) {
                        this.addCancelledEventCheckCall(this.editedOrderEventSchedule);
                    }
                    //console.log(result);
                    this.refreshViews(this.currentOrderEventSchedule!);
                }
            });
        }

        this.cancelScheduleDialogClick(true);
        //this.editedOrderEventSchedule = {} as OrderEventSchedule;
        //this.editedScheduleView = undefined;
    }

    public saveConvertMMtoCLRClick(evt: any) {
        this.recordLockHandleEvent = evt;
        this.recordLockAction = "saveConvertMMtoCLRClick";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    private allowSaveConvertMMtoCLRClick(evt: any) {
        this.recordLockHandleEvent = undefined;
        this.isLoading = true;
        this.addMultiple.quoteOrderLineID = this.selectedTrackingBoard.quoteOrderLineId;
        this.addMultiple.orderEventTypeID = this.addMultipleEventTypes.find(t => t.code == "CLR")!.orderEventTypeID;
        console.log("saveConvertMMtoCLRClick", this.addMultiple);
        this.orderService.convertMileMarkersOrderEventSchedule(this.addMultiple).subscribe(result => {
            this.isLoading = false;
            this.isEditing = false;
            this.isConvertMMtoCLR = false;
            var ok = result;
            //console.log(result);
            this.refreshViews(this.currentOrderEventSchedule!);
        });
    }

    //public saveAddMultipleMMClick(evt: any) {
    //    this.isLoading = true;
    //    this.orderService.addMileMarkersOrderEventSchedule(this.selectedTrackingBoard.quoteOrderLineId, this.addMultipleMMBeginDate, this.addMultipleMMHoursToCheck).subscribe(result => {
    //        this.isLoading = false;
    //        this.isAddMultipleMM = false;
    //        var ok = result;
    //        //console.log(result);
    //        this.refreshViews(this.currentOrderEventSchedule!);
    //    });
    //}

    public saveAddMultipleEventsClick(evt: any) {
        this.recordLockHandleEvent = evt;
        this.recordLockAction = "saveAddMultipleEventsClick";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    private allowSaveAddMultipleEventsClick(evt: any) {
        this.recordLockHandleEvent = undefined;
        this.isLoading = true;
        this.addMultiple.quoteOrderLineID = this.selectedTrackingBoard.quoteOrderLineId;

        // Get last event with EpiTimeZoneID set to use for converting dates to that timezone
        //var schedList: OrderEventSchedule[] = this.orderEventSchedule.filter(t =>
        //    t.orderEventDate < this.addMultiple.beginDate
        //    && t.epiTimeZoneID != null
        //    && t.epiTimeZoneID > 0
        //);
        //var lastTimeZoneEvent = schedList.find(t => t.orderEventSequence == Math.max(...schedList.map(t => t.orderEventSequence)));
        //this.addMultiple.beginDate = this.utilService.getLocalDateInTimeZone(this.addMultiple.beginDate, lastTimeZoneEvent!.epiTimeZone.ianaTimeZoneName);
        //console.log("saveAddMultipleEventsClick", lastTimeZoneEvent, this.addMultiple.beginDate);

        this.addMultiple.beginDate = this.utilService.getDateAsUTC(this.addMultiple.beginDate);
        console.log("saveAddMultipleEventsClick", this.addMultiple);
        this.orderService.addMultipleOrderEventSchedule(this.addMultiple).subscribe(result => {
            this.isLoading = false;
            this.isEditing = false;
            this.isAddMultipleEvents = false;
            var ok = result;
            //console.log(result);
            this.refreshViews(this.currentOrderEventSchedule!);
        });
    }

    public saveDelayMileMarkers(sched: OrderEventSchedule) {
        this.recordLockHandleSchedule = sched;
        this.recordLockAction = "saveDelayMileMarkers";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
    }

    private allowSaveDelayMileMarkers(sched: OrderEventSchedule) {
        this.recordLockHandleSchedule = {} as OrderEventSchedule;
        this.isLoading = true;
        //DelayMileMarkersOrderEventSchedule
        this.orderService.delayMileMarkersOrderEventSchedule(sched.quoteOrderLineID, sched.orderEventSequence, this.delayMinutes).subscribe(result => {
            this.isLoading = false;
            this.isAddMultipleEvents = false;
            var ok = result;
            //console.log(result);
            this.refreshViews(this.currentOrderEventSchedule!);
        });
    }

    public scheduleViewEventDateChanged(sched: OrderEventSchedule) {
        this.isScheduleViewDateValid = true;
        var minEventList = this.orderEventScheduleView.filter(s => s.completed == true && s.cancelled != true);
        var orderEventDate: Date = new Date(sched.orderEventDate);
        var orderEventDateUTC: Date = this.utilService.getLocalDateInUTC(orderEventDate);
        sched.orderEventDateUTC = orderEventDateUTC;
        //console.log("scheduleViewEventDateChanged", sched.code, orderEventDate);
        if (sched.code == "PPC") {
            var origSched = this.fullOrderEventSchedule.find(t => t.orderEventScheduleID == sched.orderEventScheduleID);
            if (orderEventDate > origSched!.orderEventDate) {
                this.isScheduleViewDateValid = false;
            }
            //console.log("scheduleViewEventDateChanged: orderEventDate before minEvent", "orderEventDate", orderEventDate, "origSched.orderEventDate", origSched!.orderEventDate);
        }
        else {
            if (minEventList.length > 0 && minEventList[minEventList.length - 1].orderEventDateUTC > orderEventDate) {
                // New event date/time occurs before last completed event
                this.isScheduleViewDateValid = false;
                //console.log("scheduleViewEventDateChanged: orderEventDate before minEvent", "orderEventDate", orderEventDate, "sched.orderEventDate", sched.orderEventDate, "minEventList[minEventList.length - 1].orderEventDateUTC", minEventList[minEventList.length - 1].orderEventDateUTC, "minEventList[minEventList.length - 1].orderEventDate", minEventList[minEventList.length - 1].orderEventDate);
            }
            for (var i = 0; i < this.orderStops.length; i++) {
                if (orderEventDate >= this.orderStops[i].arrivalDateUTC && orderEventDate <= this.orderStops[i].departDateUTC) {
                    // New event date/time occurs during stop between Arv and Dep
                    this.isScheduleViewDateValid = false;
                    //console.log("scheduleViewEventDateChanged: orderEventDate during stop", "orderEventDate", orderEventDate, "sched.orderEventDate", sched.orderEventDate, "this.orderStops[i]", this.orderStops[i]);
                }
            }
        }
        //var prevEventList = this.orderEventScheduleView.filter(s => s.orderEventDateUTC < orderEventDate);
        //var nextEventList = this.orderEventScheduleView.filter(s => s.orderEventDateUTC > orderEventDate);
        //else if (prevEventList.length > 0 && nextEventList.length > 0 && prevEventList[prevEventList.length - 1].orderStopId != 0 && prevEventList[prevEventList.length - 1].orderStopId == nextEventList[0].orderStopId) {
        //    // New event date/time occurs during stop between Arv and Dep
        //    this.isScheduleViewDateValid = false;
        //    console.log("scheduleViewEventDateChanged: orderEventDate during stop", sched.orderEventDate, prevEventList[prevEventList.length - 1].orderStopId, nextEventList[0].orderStopId);
        //}
        //console.log("scheduleViewEventDateChanged", this.isScheduleViewDateValid, "orderEventDate", orderEventDate, "sched.orderEventDate", sched.orderEventDate, "prevEventList", prevEventList, "nextEventList", nextEventList, "minEventList", minEventList);
    }

    public scheduleViewEditClick(dataItem: OrderEventScheduleView) {
        this.isRemainOpenAfterSave = true;
        if (dataItem) {
            this.editedOrderEventSchedule = Object.assign({}, this.fullOrderEventSchedule.find(s => s.orderEventScheduleID == dataItem.orderEventScheduleID)!);
            this.editedScheduleView = Object.assign({}, dataItem);
            this.editedOrderEventSchedule.orderEventDate = new Date(this.editedOrderEventSchedule.orderEventDate);
            this.editedOrderEventSchedule.orderEventDate = this.utilService.getTimeZoneDateAsLocalDate(this.editedOrderEventSchedule.orderEventDate, this.editedOrderEventSchedule.epiTimeZone.ianaTimeZoneName);
            this.scheduleViewSelectedEventType = this.editedScheduleView.nextEvent;
        }
        else {
            this.editedOrderEventSchedule = this.getNewNonStopEvent();
            this.editedScheduleView = {} as OrderEventScheduleView;
        }
        this.isScheduleViewEdit = true;
        this.isEditing = true;
        //console.log("scheduleViewEditClick", dataItem, this.editedOrderEventSchedule);
    }

    private getNewNonStopEvent() {
        var sched: any = {
            orderEventScheduleID: -1,            
            //quoteOrderID: this.selectedTrackingBoard.quoteOrderID,
            quoteOrderLineID: this.currentOrderEventSchedule!.quoteOrderLineID,
            //nextEvent: "MM",
            code: "MM",
            orderStopID: 0,
            orderEventSequence: 0,
            orderEventDate: new Date(),
            completed: false
        }
        return sched;
    }

    public getMaxDateByEventStop(sched: OrderEventSchedule): Date | undefined {
        if (!sched.orderStop) return undefined;
        if (sched.code.indexOf("Arv") > 0) {
            var nextStop = this.orderStops.find(s => s.orderStopId == sched.orderStop.orderStopId);
            //console.log(nextStop!.departDate);
            //return nextStop!.departDate;
            return undefined;
        }
        else if (sched.code.indexOf("Dep") > 0) {
            var nextStop = this.orderStops.find(s => s.stopSequence == (sched.orderStop.stopSequence + 1));
            //console.log(nextStop!.arrivalDate);
            //if (nextStop != null) return nextStop.arrivalDate;
            return undefined;
        }
        return undefined;
    }

    public getMinDateByEventStop(sched: OrderEventSchedule): Date | undefined {
        if (!sched.orderStop) return undefined;
        // Don't check minimum for BMT to allow BMT-Dep to be entered before BMT-Arv
        if (sched.code.indexOf("BMT") == 0) return undefined;
        if (sched.code.indexOf("Arv") > 0) {
            var previousStop = this.quoteOrderStops.find(s => s.stopSequence == (sched.orderStop.stopSequence - 1));
            //console.log(previousStop!.departDate);
            if (previousStop && previousStop != null) return previousStop.departDate;
        }
        else if (sched.code.indexOf("Dep") > 0) {
            var previousStop = this.quoteOrderStops.find(s => s.orderStopId == sched.orderStop.orderStopId);
            //console.log(previousStop!.arrivalDate);
            if (previousStop && previousStop != null) return previousStop.arrivalDate;
        }
        // No previous stop, so use PPC date
        var ppc = this.fullOrderEventSchedule.find(t => t.code == "PPC");
        if (ppc != null) {
            return ppc.orderEventDate;
        }
        else {
            return undefined;
        }
    }

    public getMaxDelayCount(orderEventTypeID: number) {
        var eventType = this.orderEventTypes.find(t => t.orderEventTypeID == orderEventTypeID)!;
        return eventType.maxDelayCount;
    }

    private saveReferenceNumber(sched: OrderEventSchedule) {
        var refNum = this.newReferenceNumber;
        //var refType = this.newReferenceType;

        if (sched.orderStop) {
            sched.orderStop.piecesUnit = this.getPiecesUnit(sched.orderStop.piecesUnitOfMeasureId);
            sched.orderStop.weightUnit = this.getWeightUnit(sched.orderStop.weightUnitOfMeasureId);
            sched.orderStop.lastModifiedByEmployeeId = this.utilService.getEmployeeID();

            var line = this.searchLineList.find(t => t.quoteOrderLineID == sched.quoteOrderLineID);
            var refType = this.referenceTypeList.find(t => t.referenceName == this.newReferenceType);

            if (refNum != '' && refType) {
                var newRefNum = {
                    erpReferenceTableKey: sched.orderStop.stopNumber,
                    //quoteOrderID: sched.quoteOrderLine.quoteOrderID,
                    quoteOrderID: line!.quoteOrderID,
                    orderNumber: sched.orderStop.orderNumber,
                    referenceTable: 'stops',
                    referenceTableId: sched.orderStop.orderStopId,
                    referenceType: refType.referenceName,
                    referenceTypeID: refType.referenceTypeID,
                    value: refNum,
                    createdBy: 'Web App',
                    createdDate: new Date()
                } as ReferenceNumber;
                this.isLoading = true;
                this.orderService.saveReferenceNumber(newRefNum).subscribe(refResult => {
                    this.isLoading = false;
                    var ok = refResult;
                    this.referenceNumbers.push(refResult);
                });
            }
        }
    }

    // Check Calls View
    public getNewCheckCall(eventCode: string, orderEventTypeID: number) {
        var newCheckCall = {
            quoteOrderLineId: this.selectedTrackingBoard.quoteOrderLineId,
            legHeaderNumber: this.quoteOrderLine!.apiLoadID,
            checkCallAction: '',
            orderEventTypeID: orderEventTypeID,
            originalOrderEventDateUTC: this.selectedTrackingBoard.orderEventDateUTC,
            updatedOrderEventDateUTC: this.selectedTrackingBoard.orderEventDateUTC,
            status: 'HIST',
            assignType: 'CAR',
            assignId: this.selectedTrackingBoard.carrierCode,
            cityId: 0,
            destinationCityID: 0,
            comment: '',
            currentStatusMessage: '',
            checkCallNote: '',
            currentLocationNote: '',
            etaNote: '',
            milesFromNextStop: 0,
            estimatedDriveTimeMinutes: 0,
            estimatedBreaks: 0,
            estimatedBreaksMinutes: 0,
            dateOfCall: new Date(),
            eventCode: (eventCode != "" ? eventCode : "CHK"),
            tractorNumber: 'UNKNOWN',
            lateInd: false,
            cautionInd: false,
            isEscalate: false,
            createdByEmployeeId: this.utilService.getEmployeeID(),
            createdDate: new Date()
        } as CheckCall;
        return newCheckCall;
    }

    public saveCheckCall(dataItem: CheckCall, isUTCOffset: boolean, isEmail: boolean) {
        //this.isLoading = true;
        var checkCall: CheckCall = Object.assign({}, dataItem);
        //checkCall.checkCallNote = this.checkCallNotes;

        if (isUTCOffset) {
            checkCall.dateOfCall = this.utilService.getDateAsUTC(checkCall.dateOfCall);
        }
        console.log("saveCheckCall", checkCall.dateOfCall, dataItem.dateOfCall);
        this.orderService.saveCheckCall(checkCall).subscribe(result => {
            //this.isLoading = false;
            //this.checkCalls.push(result);
            checkCall = result;
            this.trackingCheckCall.checkCallId = checkCall.checkCallId;
            if (this.isCheckCall) {
                //this.checkCallForm.controls["checkCallCityControl"].setValue("");
                this.checkCallCity = {} as SearchCityState;
                this.checkCallCityID = 0;
                this.defaultCheckCallCity = "";
                //this.checkCallNotes = "";
                //this.systemNotes = "";
                this.checkCallMiles = -1;
                this.isCheckCall = false;
                this.isNonStopEventSave = false;
                //this.stepper.next();
                //this.getCheckCalls(this.searchLine!.quoteOrderLineID);
            }
            else {
                //this.getCheckCalls(this.selectedTrackingBoard.quoteOrderLineId);
            }
            this.checkCallRefreshDate = new Date();
            if (isEmail) {
                this.sendCheckCallEmail(checkCall);
            }
        });
    }

    public checkCallCitySet(evt: any, sched: OrderEventSchedule) {
        var cityID = evt;
        this.cityService.getSearchCityStateByCityID(cityID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                var city: SearchCityState = result.resultCollection[0];
                this.checkCallCity = city;
                this.checkCallCityID = this.checkCallCity.cityID;
                this.isCheckCallCitySet = true;

                var code = this.getEventCode(sched.orderEventTypeID);
                if (code == "PPC") {
                    sched.cityID = city.cityID;
                    sched.epiTimeZoneID = city.epiTimeZoneID;
                }

                var nextStop = {} as OrderStop;
                this.orderStops.forEach((orderStop, index) => {
                    if (orderStop.arrivedInd != true && nextStop.orderStopId == null) nextStop = orderStop;
                });

                if (nextStop.orderStopId == null || nextStop.orderStopId < 1) return;

                this.fetchingRoute = true;

                this.isLoading = true;
                this.azureMapsService.getTravelEstimate(this.checkCallCity.cityID, nextStop.cityId, this.quoteOrderLine!.trailerTypeID).subscribe(result => {
                    this.isLoading = false;
                    if (result == null) return;

                    this.travelEstimate = result;
                    this.checkCallMiles = this.travelEstimate.miles;

                    this.setCheckCallFields(sched);

                    this.fetchingRoute = false;
                    //if (this.nextOrderStopEvent) {
                    //    this.nextOrderStopEvent.orderEventDate = est;
                    //    console.log("nextOrderStopEvent", this.nextOrderStopEvent, this.isCheckCall, this.trackingCheckCall!.lateInd);
                    //}
                    //console.log("checkCallCitySet", this.isCheckCall, this.trackingCheckCall!.lateInd);
                });
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    private setCheckCallFields(sched: OrderEventSchedule) {
        var code = "CHK";
        var thisCode = this.getEventCode(sched.orderEventTypeID);

        if (this.isEscalation) {
            //Override event code for escalation event
            code = "ESC";
        }
        else if (sched.orderStop) {
            code = thisCode;
        }
        else if (sched.orderEventTypeID > 0) {
            code = thisCode;
        }

        if (this.trackingCheckCall == undefined) {
            this.trackingCheckCall = this.getNewCheckCall(code, sched.orderEventTypeID);
        }
        else {
            this.trackingCheckCall.eventCode = code;
        }

        this.trackingCheckCall.orderEventScheduleID = sched.orderEventScheduleID;

        if (sched.completed != true && sched.orderStop && code != "ESC") {
            this.trackingCheckCall.eventCode = "CHK";
        }

        if (code == "ESC") {
            this.trackingCheckCall.isEscalate = true;
        }

        if (this.delayTrackingEventType == 2) {
            this.trackingCheckCall.checkCallAction = "No Answer";
        }
        else if (this.delayTrackingEventType == 1) {
            this.trackingCheckCall.checkCallAction = "No";
        }
        else if (this.delayTrackingEventType == 0) {
            this.trackingCheckCall.checkCallAction = "Completed";
        }

        var cautionMinutes = this.cseAppControls.find(a => a.appControl == 'Check Call Caution Alert');
        var lateMinutes = this.cseAppControls.find(a => a.appControl == 'Check Call Late Alert');

        var eventChangedText = "";
        if (sched.completed != true) {
            var dateFrom = new Date(this.currentOrderEventSchedule!.orderEventDate);
            var dateTo = new Date(sched.orderEventDate);
            this.trackingCheckCall.updatedOrderEventDateUTC = dateTo; //this.utilService.getDateAsUTC(dateTo);
            //dateTo = this.utilService.getLocalDateInUTC(dateTo);
            var modifiedByName = localStorage.getItem('EmployeeFullName')!;
            eventChangedText = code + " changed from "
                + dateFrom.toLocaleString()
                + " to "
                + dateTo.toLocaleString()
                //+ dateTo.toUTCString()
                //+ this.utilService.getCheckCallDateTime(dateTo);
                //+ this.utilService.getDateAsUTC(dateTo).toLocaleString()
                //+ this.utilService.getUTCDateAsLocalDate(dateTo).toLocaleString()
                + " by " + modifiedByName;
            //+ (dateFrom.getMonth() + 1) + "/" + dateFrom.getDate() + "/" + dateFrom.getFullYear() + " " +
            //console.log("saveCheckCallValidationOK", dateTo, eventChangedText);
        }

        //var city = this.checkCallForm.controls['checkCallCityControl'].value as City;
        var city = this.checkCallCity;
        var isCityChanged = (this.trackingCheckCall.cityId != city.cityID);
        this.trackingCheckCall.cityId = city.cityID;

        var orderEventDate = (sched.orderEventDate && sched.orderEventDate != null ? new Date(sched.orderEventDate) : new Date());
        this.tzOrderEventDate = new Date(orderEventDate);

        if (city.epiTimeZoneID > 0 && sched.epiTimeZoneID != city.epiTimeZoneID) {
            // Time zone changed, so update date to new time zone
            var tzOffsetCurrent = this.utilService.getTimeZoneOffset(orderEventDate, sched.epiTimeZone.ianaTimeZoneName);
            var tzOffsetNew = this.utilService.getTimeZoneOffset(orderEventDate, city.ianaTimeZoneName);
            var orderEventDateAdd = tzOffsetNew - tzOffsetCurrent;
            this.tzOrderEventDate.setSeconds(this.tzOrderEventDate.getSeconds() + orderEventDateAdd * 3600);
            //console.log("tzOffsetCurrent > tzOffsetNew", tzOffsetCurrent, tzOffsetNew, orderEventDateAdd, orderEventDate);
            //sched.orderEventDate = new Date(orderEventDate);
        }

        var nextStop = {} as OrderStop;
        this.orderStops.forEach((orderStop, index) => {
            if (orderStop.arrivedInd != true && nextStop.orderStopId == null) nextStop = orderStop;
        });

        //var est = new Date(orderEventDate);
        var est = new Date(this.tzOrderEventDate);
        var travelTimeHr: number = this.travelEstimate.miles / 50;
        var travelTimeMin: number = travelTimeHr * 60;
        var travelTimeSec: number = travelTimeMin * 60;
        var resultSec = travelTimeSec + this.travelEstimate.breakHours * 3600;
        var resultMin = resultSec / 60;
        var resultHour = resultMin / 60;
        var travelSpeed = 50;
        var isOverrideTravelTime = true;

        if (isOverrideTravelTime) {
            resultSec = (this.travelEstimate.miles / travelSpeed + this.travelEstimate.breakHours) * 3600;
            resultMin = resultSec / 60;
            resultHour = resultMin / 60;
        }

        if (isCityChanged) {
            est.setSeconds(est.getSeconds() + resultSec);
        }
        else if (this.trackingCheckCall.originalOrderEventDateUTC != null && this.trackingCheckCall.estimatedDriveTimeMinutes != null) {
            est = this.utilService.addMinutes(this.trackingCheckCall.originalOrderEventDateUTC, this.trackingCheckCall.estimatedDriveTimeMinutes);
        }
        this.trackingCheckCall.estimatedDeliveryDate = est;

        var travelHours = Math.floor(resultHour >= 1 ? resultHour : 0);
        var travelMin = Math.round(resultMin - travelHours * 60);
        this.trackingCheckCall.estimatedDriveTimeMinutes = Math.round(resultMin);
        var travelText = "Estimated drive time: ";
        if (travelHours > 0) {
            travelText += travelHours;
            if (travelHours == 1) {
                travelText += " hour ";
            }
            else {
                travelText += " hours ";
            }
        }
        travelText += travelMin + " minutes ";

        if (this.travelEstimate.breaks > 0) {
            this.trackingCheckCall.estimatedBreaks = this.travelEstimate.breaks;
            this.trackingCheckCall.estimatedBreaksMinutes = this.travelEstimate.breakHours * 60;
            var hoursUnit: string = this.travelEstimate.breakHours == 1 ? "hour" : "hours";
            var breaksUnit: string = this.travelEstimate.breaks == 1 ? "break" : "breaks";
            travelText += "(includes " + this.travelEstimate.breaks + " " + breaksUnit + " for " + this.travelEstimate.breakHours + " " + hoursUnit + ") ";
        }

        var eta = (est.getMonth() + 1) + '/' + est.getDate() + '/' + est.getFullYear() + ' ' +
            (est.getHours() < 10 ? '0' + est.getHours() : est.getHours()) + ':' +
            (est.getMinutes() < 10 ? '0' + est.getMinutes() : est.getMinutes());

        var lateDate = new Date(est);
        var cautionDate = new Date(est);
        var nextDate = (nextStop.latestDate > nextStop.arrivalDate ? nextStop.latestDate : nextStop.arrivalDate);

        lateDate.setMinutes(lateDate.getMinutes() - parseInt(lateMinutes!.appSettingValue));
        cautionDate.setMinutes(cautionDate.getMinutes() - parseInt(cautionMinutes!.appSettingValue));

        this.trackingCheckCall.lateInd = lateDate > nextDate;
        if (this.trackingCheckCall.lateInd == null || !this.trackingCheckCall.lateInd) this.trackingCheckCall.cautionInd = cautionDate > nextDate;

        if (nextStop.orderStopId > 0) {
            this.trackingCheckCall.destinationCityID = nextStop.cityId;
        }

        if (this.checkCallMiles >= 0) {
            this.trackingCheckCall.milesFromNextStop = this.checkCallMiles;
        };
        //this.trackingCheckCall.milesFromNextStop = this.travelEstimate.miles;

        var currentStatus = "";
        var currentLocation = "";
        if (this.isCheckCallCitySet) {
            var searchStop = this.getSearchOrderStop(nextStop.orderStopId);
            var stopCustomer: string = "";
            var cityStateZip: string = "";
            if (searchStop != null) {
                stopCustomer = searchStop.stopCustomer;
                cityStateZip = searchStop.cityStateZip;
            }
            if (this.trackingCheckCall.lateInd == true) {
                currentStatus = "CAN'T MAKE IT: " + stopCustomer + ". ETA " + eta + ".";
            }
            else if (this.trackingCheckCall.cautionInd == true) {
                currentStatus = "CAUTION: " + stopCustomer + ". ETA " + eta + ".";
            }
            if (city && city.cityST != null) {
                currentLocation = city.cityST + ' ' + city.zip + ' ' + this.travelEstimate.miles + " miles from " + cityStateZip + ".  " + travelText + " - " + eta;
            }
        }

        this.trackingCheckCall.currentStatusMessage = currentStatus;
        if (this.trackingCheckCall.currentLocationNote == null || this.trackingCheckCall.currentLocationNote == "") {
            this.trackingCheckCall.currentLocationNote = currentLocation;
        }
        this.trackingCheckCall.etaNote = eventChangedText;

        var comment = "";
        //if (this.trackingCheckCall.comment == null || this.trackingCheckCall.comment == "") {
        if (this.delayTrackingEventType == 2) {
            // No Answer
            comment = "No Answer";
            //comment += this.trackingCheckCall.checkCallNote;
            comment += "; ";
            comment += eventChangedText;
        }
        else if (this.isCheckCallCitySet && currentLocation != "") {
            this.trackingCheckCall.nextETADateUTC = est; //this.utilService.getDateAsUTC(est);
            //comment = this.trackingCheckCall.checkCallNote;
            //if (comment.length > 0) {
            //    comment += ";\n";
            //}
            comment += currentLocation + " ETA";
        }
        else {
            //comment = this.trackingCheckCall.checkCallNote;
            //if (comment.length > 0) {
            //    comment += ";\n";
            //}
            //this.trackingCheckCall.checkCallNote = this.systemNotes;
            comment += eventChangedText;
        }
        this.trackingCheckCall.comment = comment;
        //}
        //this.systemNotes = comment;
    }

    private checkAndAddEmployee(employeeID: number, employees: Employee[]) {
        if (employeeID > 0) {
            var emp = this.allEmployees.find(t => t.employeeId == employeeID);
            if (emp != null) {
                var idx = employees.findIndex(e => e.employeeId == employeeID && e.email != "");
                if (idx == null || idx < 0) employees.push(emp);
            }
        }
        return employees;
    }

    public sendCheckCallEmail(dataItem: CheckCall) {
        if (this.allEmployees.length > 0) {
            this.sendCheckCallEmailContinue(dataItem);
        }
        else {
            this.employeeService.getActiveEmployees().subscribe(result => {
                this.allEmployees = result;
                this.sendCheckCallEmailContinue(dataItem);
            });
        }
    }

    public sendCheckCallEmailContinue(dataItem: CheckCall) {
        var employees: Employee[] = [];
        var extraEmails: string = "";

        if (this.searchLine.internalTrackingEmail != "") {
            extraEmails = this.searchLine.internalTrackingEmail;
        }
        else {
            employees = this.checkAndAddEmployee(this.searchLine.opsRepEmployeeID, employees);
            employees = this.checkAndAddEmployee(this.searchLine.createdByEmployeeID, employees);
            employees = this.checkAndAddEmployee(this.searchLine.accountManagerEmployeeID, employees);
        }
        employees = this.checkAndAddEmployee(this.searchLine.csrEmployeeID, employees);

        //if (this.searchLine.opsRepEmployeeID > 0) {
        //    var opsRepEmployee = this.allEmployees.filter(e => e.employeeId == this.searchLine.opsRepEmployeeID && e.email != "");
        //    if (opsRepEmployee.length > 0) {
        //        employees.push(opsRepEmployee[0]);
        //    }
        //}

        //var idx = -1;

        //idx = employees.findIndex(e => e.employeeId == this.searchLine.createdByEmployeeID);
        //var createdByEmployee = this.allEmployees.filter(e => e.employeeId == this.searchLine.createdByEmployeeID && e.email != "");
        //if (idx == null || idx < 0) employees.push(createdByEmployee[0]);

        //if (this.searchLine.accountManagerEmployeeID > 0) {
        //    var accountRep = this.allEmployees.filter(e => e.employeeId == this.searchLine.accountManagerEmployeeID && e.email != "");
        //    if (accountRep.length > 0) {
        //        idx = employees.findIndex(e => e.employeeId == this.searchLine.accountManagerEmployeeID);
        //        if (idx == null || idx < 0) employees.push(accountRep[0]);
        //    }
        //}

        //idx = employees.findIndex(e => e.employeeId == this.carrierRep.employeeId);
        //if (idx == null || idx < 0) employees.push(this.carrierRep);

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            showNotes: false,
            showCheckCallNotes: true,
            showSystemNotes: true,
            employees: employees,
            extraEmails: extraEmails,
            isEscalation: this.isEscalation
        }

        console.log("sendCheckCallEmail", dataItem, this.trackingCheckCall, this.searchLine, employees, dialogConfig.data);

        const dialogRef = this.dialog.open(EmployeeMultiselectDialog, dialogConfig);

        //this.trackingCheckCall!.checkCallNote = this.checkCallNotes;

        dialogRef.componentInstance.checkCallNotes = dataItem.checkCallNote;
        dialogRef.componentInstance.systemNotes = dataItem.comment;

        dialogRef.afterClosed().subscribe(result => {
            if (result == null ||
                (
                    (result.selectedEmployees == null || result.selectedEmployees.length < 1)
                    && (result.selectedGroupId == null || result.selectedGroupId < 1)
                    && (result.selectedEmails == null || result.selectedEmails.length < 1)
                )
            ) return;

            var emails = "";
            var trackingEmail = this.orderAppControls.find(a => a.appControl == "Tracking Alert Email");
            if (trackingEmail) {
                emails += trackingEmail.appSettingValue + "|";
            }
            result.selectedEmployees.forEach(e => {
                if (e.email && e.email != "") {
                    emails += e.email + "|";
                }
            });
            var typedEmails = result.selectedEmails.split(",");
            typedEmails.forEach(e => {
                var email = e.trim();
                if (emails.indexOf(email) < 0 && email != undefined) {
                    emails += email + "|";
                }
            });

            var subject = "";
            if (this.isEscalation || dataItem.eventCode == "ESC") {
                subject = "ESCALATION alert for order #" + this.searchLine.orderNumber;
            }

            this.isLoading = true;
            this.orderService.sendQuoteOrderEmail(this.searchLine.quoteOrderID, this.searchLine.orderNumber, emails, result.selectedGroupId, subject, result.checkCallNotes, dataItem.checkCallId, result.systemNotes, true, false, dataItem.eventCode, this.isEscalation).subscribe(emailResult => {
                this.isLoading = false;
                this.isEscalation = false;
                var ok = emailResult;
                this.refreshViews(this.currentOrderEventSchedule!);
            });
        });
    }

    private sendTrackingEmail(sched: OrderEventSchedule, quoteOrderID: number, orderNumber: string, checkCallNotes: string) {
        if (sched.notificationEmails != null && sched.notificationEmails != "") {
            var trackingEmail: TrackingEventEmail =
            {
                clientAbbr: "ALS",
                emails: sched.notificationEmails,
                quoteOrderLineId: sched.quoteOrderLineID,
                quoteOrderID: quoteOrderID,
                eventCode: "CLR",
                notes: checkCallNotes + " as of " + formatDate(sched.orderEventDate, "MM/dd/yyyy HH:mm", "en-US"),
                subject: "Load #: " + orderNumber + " tracking update",
                fromEmployeeId: sched.completedByEmployeeID,
                isImportant: false,
                isIncludeStops: false,
                isIncludeAdaptiveCard: false
            };
            this.orderService.sendTrackingEventEmail(trackingEmail).subscribe(emailResult => {
                var ok = emailResult;
            });
        }
    }

    public toggleFlag(div: string) {
        this.divFlags[div] = !this.divFlags[div];
        if (div == "alerts" && this.divFlags['alerts'] == true) {
            this.getSearchMacropointStopAlerts();
        }
    }

    private getErrorCollectionMessage(result: APIResponse) {
        var msg = "";
        if (result.message != "OK") {
            msg += result.message + " ";
        }
        for (var i = 0; i < result.errorCollection.length; i++) {
            msg += result.errorCollection[i].Message + " ";
        }
        return msg;
    }

    public getTagTypes(idList: string) {
        var tagTypes: SearchTagType[] = [];
        if (idList && idList != "") {
            var arr: number[] = [];
            arr = idList.replace(/, +/g, ",").split(",").map(Number);
            for (var i = 0; i < arr.length; i++) {
                var idx: number = this.tagTypeList.findIndex(t => t.tagTypeID == arr[i]);
                if (idx >= 0) {
                    tagTypes.push(this.tagTypeList[idx]);
                }
            }
        }
        return tagTypes;
    }

    private initRecordLock() {
        this.recordLockAction = "";
        this.recordLockService.continueRecordLockObserver.subscribe(result => {
            //console.log("tracking-dashboard:initRecordLock:isContinueRecorLock", this.recordLockService.isContinueRecordLock);
            if (this.recordLockService.isContinueRecordLock) {
                if (this.quoteOrderID > 0) {
                    this.getQuoteOrder(this.quoteOrderID);
                }
                //this.continueRecordLockAction();
            }
        });
        this.recordLockService.cancelOverrideObserver.subscribe(result => {
            //console.log("order-form:initRecordLock:isCancelOverride", this.recordLockService.isCancelOverride);
            if (this.recordLockService.isCancelOverride) {
                this.closeTrackingInfo(this.selectedTrackingBoard);
            }
        });
        this.recordLockService.timeoutRecordLockObserver.subscribe(result => {
            if (this.recordLockService.isRecordLockTimeout) {
                //console.log("tracking-dashboard:initRecordLock:isRecordLockTimeout", this.recordLockAction, this.selectedTrackingBoard.quoteOrderID, this.recordLockService.searchRecordLock);
                this.recordLockService.clearRecordLock("QuoteOrder", this.selectedTrackingBoard.quoteOrderID, this.recordLockSource);
                //this.recordLockService.clearRecordLock(this.recordLockService.recordLock.recordLockID);
                //this.continueRecordLockAction();
            }
        });
        this.recordLockService.timeoutConfirmObserver.subscribe(result => {
            if (this.recordLockService.isConfirmTimeout) {
                //console.log("tracking-dashboard:initRecordLock:timeoutConfirmObserver", this.recordLockAction, this.selectedTrackingBoard.quoteOrderID, this.recordLockService.searchRecordLock);
                //this.recordLockService.resetRecordLock();
                //this.navigateQuoteOrder(this.quoteOrderID, true);
                //this.getQuoteOrder(this.selectedTrackingBoard.quoteOrderID);
                this.closeTrackingInfo(this.selectedTrackingBoard);
            }
        });
        this.recordLockService.hasRecordLockObserver.subscribe(result => {
            var handleEvent = Object.assign({}, this.recordLockHandleEvent);
            var handleSched = Object.assign({}, this.recordLockHandleSchedule);
            console.log("order-form:handleRecordLock:isContinueRecorLock", this.recordLockService.isContinueRecordLock, this.recordLockAction, handleEvent, handleSched);
            if (this.recordLockService.hasRecordLock) {
                if (this.recordLockAction == "resetScheduleClick") {
                    this.allowResetScheduleClick();
                }
                else if (this.recordLockAction == "recreateScheduleClick") {
                    this.allowRecreateScheduleClick(this.recordLockHandleEvent, this.recordLockHandleSchedule);
                }
                else if (this.recordLockAction == "saveSearchQuoteOrderLine") {
                    this.allowSaveSearchQuoteOrderLine();
                }
                else if (this.recordLockAction == "saveOrder") {
                    this.allowSaveOrder();
                }
                else if (this.recordLockAction == "saveOrderEventClick") {
                    this.allowSaveOrderEventClick(this.recordLockHandleEvent, this.recordLockHandleSchedule, false);
                }
                else if (this.recordLockAction == "saveAndEmailClick") {
                    this.allowSaveAndEmailClick(this.recordLockHandleEvent, this.recordLockHandleSchedule);
                }
                else if (this.recordLockAction == "saveNonStopEventClick") {
                    this.allowSaveNonStopEventClick(this.recordLockHandleEvent, this.recordLockHandleSchedule);
                }
                else if (this.recordLockAction == "deleteRemainingMMClick") {
                    this.allowDeleteRemainingMMClick();
                }
                else if (this.recordLockAction == "saveScheduleViewClick") {
                    this.allowSaveScheduleViewClick();
                }
                else if (this.recordLockAction == "saveConvertMMtoCLRClick") {
                    this.allowSaveConvertMMtoCLRClick(this.recordLockHandleEvent);
                }
                else if (this.recordLockAction == "saveAddMultipleEventsClick") {
                    this.allowSaveAddMultipleEventsClick(this.recordLockHandleEvent);
                }
                else if (this.recordLockAction == "saveDelayMileMarkers") {
                    this.allowSaveDelayMileMarkers(this.recordLockHandleSchedule);
                }
                else if (this.recordLockAction == "resetScheduleClick") {
                    this.allowResetScheduleClick();
                }
                this.recordLockAction = "";
            }
        });
    }

    private handleRecordLock(id: number) {
        //console.log("order-form:handleRecordLock", id);
        this.recordLockService.handleRecordLock("QuoteOrder", id, this.recordLockSource);
    }

    //private continueRecordLockAction() {
    //    if (!this.recordLockService.isLocked) {
    //        if (this.recordLockAction == "viewTrackingInfo") {
    //            this.getQuoteOrder(this.selectedTrackingBoard.quoteOrderID);
    //        }
    //        this.recordLockAction = "";
    //    }
    //}
}
